import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TranslatorService {


  englishText: any = {
    checkIn: "Check-in",
    alreadyCheckedIn: "Checked-in",
    scanQR: "Scan QR Code",
    enterRef:"Enter Booking Ref",
    enterInfo:"Enter Personal Info",
    enterYourRef:"Enter your booking ref",
    mandatoryRef:"Reference is mandatory",
    submit:"Submit",
    cancel:"Cancel",
    retry:"Retry",
    finish:"Finish",
    lastname:"Last name",
    lastnameMandatory:"Last name is mandatory",
    postcode:"Postcode",
    postcodeMandatory:"Postcode is mandatory",
    dob:"Date of Birth",
    dobMandatory:"Date of birth is mandatory",
    dateExample:"For example, 27 03 2021",
    day:"Day",
    month:"Month",
    year:"Year",
    bookingFound:"Booking found",
    bookingNotFound:"Booking not found",
    tryAgain:"Please try again",
    bookingCheckedIn:"Booking already checked in",
    bookingNotToday:"Booking cannot be checked in today",
    thanks:"Thanks ",
    checkedIn:"You are now checked in",
    showQR:"Show QR code to camera",
    timer:"Returning to homescreen in 00:0",
    pickDay:"Please select your birth date",
    pickMonth:"Please select your birth month",
    errorWarn:"An unexpected error occurred. Please retry.",
    networkOffline:"Connection has been lost. Please contact your system administrator."
  }
  selectedLanguage = "english"
  selectedLanguageCode = "en"
  languages: any = {
    "Afrikaans": "af",
    "Albanian": "sq",
    "Amharic": "am",
    "Arabic": "ar",
    "Armenian": "hy",
    "Assamese": "as",
    "Aymara": "ay",
    "Azerbaijani": "az",
    "Bambara": "bm",
    "Basque": "eu",
    "Belarusian": "be",
    "Bengali": "bn",
    "Bhojpuri": "bho",
    "Bosnian": "bs",
    "Bulgarian": "bg",
    "Catalan": "ca",
    "Cebuano": "ceb",
    "Chinese (Simplified)": "zh-CN or zh (BCP-47)",
    "Chinese (Traditional)": "zh-TW (BCP-47)",
    "Corsican": "co",
    "Croatian": "hr",
    "Czech": "cs",
    "Danish": "da",
    "Dhivehi": "dv",
    "Dogri": "doi",
    "Dutch": "nl",
    "English": "en",
    "Esperanto": "eo",
    "Estonian": "et",
    "Ewe": "ee",
    "Filipino (Tagalog)": "fil",
    "Finnish": "fi",
    "French": "fr",
    "Frisian": "fy",
    "Galician": "gl",
    "Georgian": "ka",
    "German": "de",
    "Greek": "el",
    "Guarani": "gn",
    "Gujarati": "gu",
    "Haitian Creole": "ht",
    "Hausa": "ha",
    "Hawaiian": "haw",
    "Hebrew": "he or iw",
    "Hindi": "hi",
    "Hmong": "hmn",
    "Hungarian": "hu",
    "Icelandic": "is",
    "Igbo": "ig",
    "Ilocano": "ilo",
    "Indonesian": "id",
    "Irish": "ga",
    "Italian": "it",
    "Japanese": "ja",
    "Javanese": "jv or jw",
    "Kannada": "kn",
    "Kazakh": "kk",
    "Khmer": "km",
    "Kinyarwanda": "rw",
    "Konkani": "gom",
    "Korean": "ko",
    "Krio": "kri",
    "Kurdish": "ku",
    "Kurdish (Sorani)": "ckb",
    "Kyrgyz": "ky",
    "Lao": "lo",
    "Latin": "la",
    "Latvian": "lv",
    "Lingala": "ln",
    "Lithuanian": "lt",
    "Luganda": "lg",
    "Luxembourgish": "lb",
    "Macedonian": "mk",
    "Maithili": "mai",
    "Malagasy": "mg",
    "Malay": "ms",
    "Malayalam": "ml",
    "Maltese": "mt",
    "Maori": "mi",
    "Marathi": "mr",
    "Meiteilon (Manipuri)": "mni-Mtei",
    "Mizo": "lus",
    "Mongolian": "mn",
    "Myanmar (Burmese)": "my",
    "Nepali": "ne",
    "Norwegian": "no",
    "Nyanja (Chichewa)": "ny",
    "Odia (Oriya)": "or",
    "Oromo": "om",
    "Pashto": "ps",
    "Persian": "fa",
    "Polish": "pl",
    "Portuguese (Portugal, Brazil) ": "pt",
    "Punjabi": "pa",
    "Quechua": "qu",
    "Romanian": "ro",
    "Russian": "ru",
    "Samoan": "sm",
    "Sanskrit": "sa",
    "Scots Gaelic": "gd",
    "Sepedi": "nso",
    "Serbian": "sr",
    "Sesotho": "st",
    "Shona": "sn",
    "Sindhi": "sd",
    "Sinhala (Sinhalese)": "si",
    "Slovak": "sk",
    "Slovenian": "sl",
    "Somali": "so",
    "Spanish": "es",
    "Sundanese": "su",
    "Swahili": "sw",
    "Swedish": "sv",
    "Tagalog (Filipino)": "tl",
    "Tajik": "tg",
    "Tamil": "ta",
    "Tatar": "tt",
    "Telugu": "te",
    "Thai": "th",
    "Tigrinya": "ti",
    "Tsonga": "ts",
    "Turkish": "tr",
    "Turkmen": "tk",
    "Twi (Akan)": "ak",
    "Ukrainian": "uk",
    "Urdu": "ur",
    "Uyghur": "ug",
    "Uzbek": "uz",
    "Vietnamese": "vi",
    "Welsh": "cy",
    "Xhosa": "xh",
    "Yiddish": "yi",
    "Yoruba": "yo",
    "Zulu": "zu"
  }

  languageInfoTable: any = [
    {
      "Culture .NET": "af",
      "English": "Afrikaans",
      "Native": "Afrikaans",
      "Two letter": "af",
      "Three letter": "afr",
      "Three letter language name": "AFK",
      "LCID": 54,
      "IETF language tag": "af",
      "flag code": ""
    },
    {
      "Culture .NET": "af-ZA",
      "English": "Afrikaans (South Africa)",
      "Native": "Afrikaans (Suid Afrika)",
      "Two letter": "af",
      "Three letter": "afr",
      "Three letter language name": "AFK",
      "LCID": 1078,
      "IETF language tag": "af-ZA",
      "flag code": "za South Africa"
    },
    {
      "Culture .NET": "am-ET",
      "English": "Amharic (Ethiopia)",
      "Native": "አማርኛ (ኢትዮጵያ)",
      "Two letter": "am",
      "Three letter": "amh",
      "Three letter language name": "AMH",
      "LCID": 1118,
      "IETF language tag": "am-ET",
      "flag code": "et Ethiopia"
    },
    {
      "Culture .NET": "ar",
      "English": "Arabic",
      "Native": "العربية",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARA",
      "LCID": 1,
      "IETF language tag": "ar",
      "flag code": ""
    },
    {
      "Culture .NET": "ar-AE",
      "English": "Arabic (U.A.E.)",
      "Native": "العربية (الإمارات العربية المتحدة)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARU",
      "LCID": 14337,
      "IETF language tag": "ar-AE",
      "flag code": "ae U.A.E."
    },
    {
      "Culture .NET": "ar-BH",
      "English": "Arabic (Bahrain)",
      "Native": "العربية (البحرين)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARH",
      "LCID": 15361,
      "IETF language tag": "ar-BH",
      "flag code": "bh Bahrain"
    },
    {
      "Culture .NET": "ar-DZ",
      "English": "Arabic (Algeria)",
      "Native": "العربية (الجزائر)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARG",
      "LCID": 5121,
      "IETF language tag": "ar-DZ",
      "flag code": "dz Algeria"
    },
    {
      "Culture .NET": "ar-EG",
      "English": "Arabic (Egypt)",
      "Native": "العربية (مصر)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARE",
      "LCID": 3073,
      "IETF language tag": "ar-EG",
      "flag code": "eg Egypt"
    },
    {
      "Culture .NET": "ar-IQ",
      "English": "Arabic (Iraq)",
      "Native": "العربية (العراق)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARI",
      "LCID": 2049,
      "IETF language tag": "ar-IQ",
      "flag code": "iq Iraq"
    },
    {
      "Culture .NET": "ar-JO",
      "English": "Arabic (Jordan)",
      "Native": "العربية (الأردن)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARJ",
      "LCID": 11265,
      "IETF language tag": "ar-JO",
      "flag code": "jo Jordan"
    },
    {
      "Culture .NET": "ar-KW",
      "English": "Arabic (Kuwait)",
      "Native": "العربية (الكويت)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARK",
      "LCID": 13313,
      "IETF language tag": "ar-KW",
      "flag code": "kw Kuwait"
    },
    {
      "Culture .NET": "ar-LB",
      "English": "Arabic (Lebanon)",
      "Native": "العربية (لبنان)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARB",
      "LCID": 12289,
      "IETF language tag": "ar-LB",
      "flag code": "lb Lebanon"
    },
    {
      "Culture .NET": "ar-LY",
      "English": "Arabic (Libya)",
      "Native": "العربية (ليبيا)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARL",
      "LCID": 4097,
      "IETF language tag": "ar-LY",
      "flag code": "ly Libya"
    },
    {
      "Culture .NET": "ar-MA",
      "English": "Arabic (Morocco)",
      "Native": "العربية (المملكة المغربية)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARM",
      "LCID": 6145,
      "IETF language tag": "ar-MA",
      "flag code": "ma Morocco"
    },
    {
      "Culture .NET": "ar-OM",
      "English": "Arabic (Oman)",
      "Native": "العربية (عمان)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARO",
      "LCID": 8193,
      "IETF language tag": "ar-OM",
      "flag code": "om Oman"
    },
    {
      "Culture .NET": "ar-QA",
      "English": "Arabic (Qatar)",
      "Native": "العربية (قطر)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARQ",
      "LCID": 16385,
      "IETF language tag": "ar-QA",
      "flag code": "qa Qatar"
    },
    {
      "Culture .NET": "ar-SA",
      "English": "Arabic (Saudi Arabia)",
      "Native": "العربية (المملكة العربية السعودية)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARA",
      "LCID": 1025,
      "IETF language tag": "ar-SA",
      "flag code": "sa Saudi Arabia"
    },
    {
      "Culture .NET": "ar-SY",
      "English": "Arabic (Syria)",
      "Native": "العربية (سوريا)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARS",
      "LCID": 10241,
      "IETF language tag": "ar-SY",
      "flag code": "sy Syria"
    },
    {
      "Culture .NET": "ar-TN",
      "English": "Arabic (Tunisia)",
      "Native": "العربية (تونس)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ART",
      "LCID": 7169,
      "IETF language tag": "ar-TN",
      "flag code": "tn Tunisia"
    },
    {
      "Culture .NET": "ar-YE",
      "English": "Arabic (Yemen)",
      "Native": "العربية (اليمن)",
      "Two letter": "ar",
      "Three letter": "ara",
      "Three letter language name": "ARY",
      "LCID": 9217,
      "IETF language tag": "ar-YE",
      "flag code": "ye Yemen"
    },
    {
      "Culture .NET": "arn-CL",
      "English": "Mapudungun (Chile)",
      "Native": "Mapudungun (Chile)",
      "Two letter": "arn",
      "Three letter": "arn",
      "Three letter language name": "MPD",
      "LCID": 1146,
      "IETF language tag": "arn-CL",
      "flag code": "cl Chile"
    },
    {
      "Culture .NET": "as-IN",
      "English": "Assamese (India)",
      "Native": "অসমীয়া (ভাৰত)",
      "Two letter": "as",
      "Three letter": "asm",
      "Three letter language name": "ASM",
      "LCID": 1101,
      "IETF language tag": "as-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "az",
      "English": "Azeri",
      "Native": "Azərbaycan­ılı",
      "Two letter": "az",
      "Three letter": "aze",
      "Three letter language name": "AZE",
      "LCID": 44,
      "IETF language tag": "az",
      "flag code": ""
    },
    {
      "Culture .NET": "az-Cyrl-AZ",
      "English": "Azeri (Cyrillic) (Azerbaijan)",
      "Native": "Азәрбајҹан (Азәрбајҹан)",
      "Two letter": "az",
      "Three letter": "aze",
      "Three letter language name": "AZE",
      "LCID": 2092,
      "IETF language tag": "az-Cyrl-AZ",
      "flag code": "az Azerbaijan"
    },
    {
      "Culture .NET": "az-Latn-AZ",
      "English": "Azeri (Latin) (Azerbaijan)",
      "Native": "Azərbaycan­ılı (Azərbaycanca)",
      "Two letter": "az",
      "Three letter": "aze",
      "Three letter language name": "AZE",
      "LCID": 1068,
      "IETF language tag": "az-Latn-AZ",
      "flag code": "az Azerbaijan"
    },
    {
      "Culture .NET": "ba-RU",
      "English": "Bashkir (Russia)",
      "Native": "Башҡорт (Россия)",
      "Two letter": "ba",
      "Three letter": "bak",
      "Three letter language name": "BAS",
      "LCID": 1133,
      "IETF language tag": "ba-RU",
      "flag code": "ru Russia"
    },
    {
      "Culture .NET": "be",
      "English": "Belarusian",
      "Native": "Беларускі",
      "Two letter": "be",
      "Three letter": "bel",
      "Three letter language name": "BEL",
      "LCID": 35,
      "IETF language tag": "be",
      "flag code": ""
    },
    {
      "Culture .NET": "be-BY",
      "English": "Belarusian (Belarus)",
      "Native": "Беларускі (Беларусь)",
      "Two letter": "be",
      "Three letter": "bel",
      "Three letter language name": "BEL",
      "LCID": 1059,
      "IETF language tag": "be-BY",
      "flag code": "by Belarus"
    },
    {
      "Culture .NET": "bg",
      "English": "Bulgarian",
      "Native": "български",
      "Two letter": "bg",
      "Three letter": "bul",
      "Three letter language name": "BGR",
      "LCID": 2,
      "IETF language tag": "bg",
      "flag code": ""
    },
    {
      "Culture .NET": "bg-BG",
      "English": "Bulgarian (Bulgaria)",
      "Native": "български (България)",
      "Two letter": "bg",
      "Three letter": "bul",
      "Three letter language name": "BGR",
      "LCID": 1026,
      "IETF language tag": "bg-BG",
      "flag code": "bg Bulgaria"
    },
    {
      "Culture .NET": "bn-BD",
      "English": "Bengali (Bangladesh)",
      "Native": "বাংলা (বাংলাদেশ)",
      "Two letter": "bn",
      "Three letter": "bng",
      "Three letter language name": "BNB",
      "LCID": 2117,
      "IETF language tag": "bn-BD",
      "flag code": "bd Bangladesh"
    },
    {
      "Culture .NET": "bn-IN",
      "English": "Bengali (India)",
      "Native": "বাংলা (ভারত)",
      "Two letter": "bn",
      "Three letter": "bng",
      "Three letter language name": "BNG",
      "LCID": 1093,
      "IETF language tag": "bn-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "bo-CN",
      "English": "Tibetan (People's Republic of China)",
      "Native": "བོད་ཡིག (ཀྲུང་ཧྭ་མི་དམངས་སྤྱི་མཐུན་རྒྱལ་ཁབ།)",
      "Two letter": "bo",
      "Three letter": "bod",
      "Three letter language name": "BOB",
      "LCID": 1105,
      "IETF language tag": "bo-CN",
      "flag code": "cn People's Republic of China"
    },
    {
      "Culture .NET": "br-FR",
      "English": "Breton (France)",
      "Native": "brezhoneg (Frañs)",
      "Two letter": "br",
      "Three letter": "bre",
      "Three letter language name": "BRE",
      "LCID": 1150,
      "IETF language tag": "br-FR",
      "flag code": "fr France"
    },
    {
      "Culture .NET": "bs-Cyrl-BA",
      "English": "Bosnian (Cyrillic) (Bosnia and Herzegovina)",
      "Native": "босански (Босна и Херцеговина)",
      "Two letter": "bs",
      "Three letter": "bsc",
      "Three letter language name": "BSC",
      "LCID": 8218,
      "IETF language tag": "bs-Cyrl-BA",
      "flag code": "ba Bosnia and Herzegovina"
    },
    {
      "Culture .NET": "bs-Latn-BA",
      "English": "Bosnian (Latin) (Bosnia and Herzegovina)",
      "Native": "bosanski (Bosna i Hercegovina)",
      "Two letter": "bs",
      "Three letter": "bsb",
      "Three letter language name": "BSB",
      "LCID": 5146,
      "IETF language tag": "bs-Latn-BA",
      "flag code": "ba Bosnia and Herzegovina"
    },
    {
      "Culture .NET": "ca",
      "English": "Catalan",
      "Native": "català",
      "Two letter": "ca",
      "Three letter": "cat",
      "Three letter language name": "CAT",
      "LCID": 3,
      "IETF language tag": "ca",
      "flag code": ""
    },
    {
      "Culture .NET": "ca-ES",
      "English": "Catalan (Catalan)",
      "Native": "català (català)",
      "Two letter": "ca",
      "Three letter": "cat",
      "Three letter language name": "CAT",
      "LCID": 1027,
      "IETF language tag": "ca-ES",
      "flag code": "es Catalan"
    },
    {
      "Culture .NET": "co-FR",
      "English": "Corsican (France)",
      "Native": "Corsu (France)",
      "Two letter": "co",
      "Three letter": "cos",
      "Three letter language name": "COS",
      "LCID": 1155,
      "IETF language tag": "co-FR",
      "flag code": "fr France"
    },
    {
      "Culture .NET": "cs",
      "English": "Czech",
      "Native": "čeština",
      "Two letter": "cs",
      "Three letter": "ces",
      "Three letter language name": "CSY",
      "LCID": 5,
      "IETF language tag": "cs",
      "flag code": ""
    },
    {
      "Culture .NET": "cs-CZ",
      "English": "Czech (Czech Republic)",
      "Native": "čeština (Česká republika)",
      "Two letter": "cs",
      "Three letter": "ces",
      "Three letter language name": "CSY",
      "LCID": 1029,
      "IETF language tag": "cs-CZ",
      "flag code": "cz Czech Republic"
    },
    {
      "Culture .NET": "cy-GB",
      "English": "Welsh (United Kingdom)",
      "Native": "Cymraeg (y Deyrnas Unedig)",
      "Two letter": "cy",
      "Three letter": "cym",
      "Three letter language name": "CYM",
      "LCID": 1106,
      "IETF language tag": "cy-GB",
      "flag code": "gb United Kingdom"
    },
    {
      "Culture .NET": "da",
      "English": "Danish",
      "Native": "dansk",
      "Two letter": "da",
      "Three letter": "dan",
      "Three letter language name": "DAN",
      "LCID": 6,
      "IETF language tag": "da",
      "flag code": ""
    },
    {
      "Culture .NET": "da-DK",
      "English": "Danish (Denmark)",
      "Native": "dansk (Danmark)",
      "Two letter": "da",
      "Three letter": "dan",
      "Three letter language name": "DAN",
      "LCID": 1030,
      "IETF language tag": "da-DK",
      "flag code": "dk Denmark"
    },
    {
      "Culture .NET": "de",
      "English": "German",
      "Native": "Deutsch",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DEU",
      "LCID": 7,
      "IETF language tag": "de",
      "flag code": ""
    },
    {
      "Culture .NET": "de-AT",
      "English": "German (Austria)",
      "Native": "Deutsch (Österreich)",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DEA",
      "LCID": 3079,
      "IETF language tag": "de-AT",
      "flag code": "at Austria"
    },
    {
      "Culture .NET": "de-CH",
      "English": "German (Switzerland)",
      "Native": "Deutsch (Schweiz)",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DES",
      "LCID": 2055,
      "IETF language tag": "de-CH",
      "flag code": "ch Switzerland"
    },
    {
      "Culture .NET": "de-DE",
      "English": "German (Germany)",
      "Native": "Deutsch (Deutschland)",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DEU",
      "LCID": 1031,
      "IETF language tag": "de-DE",
      "flag code": "de Germany"
    },
    {
      "Culture .NET": "de-LI",
      "English": "German (Liechtenstein)",
      "Native": "Deutsch (Liechtenstein)",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DEC",
      "LCID": 5127,
      "IETF language tag": "de-LI",
      "flag code": "li Liechtenstein"
    },
    {
      "Culture .NET": "de-LU",
      "English": "German (Luxembourg)",
      "Native": "Deutsch (Luxemburg)",
      "Two letter": "de",
      "Three letter": "deu",
      "Three letter language name": "DEL",
      "LCID": 4103,
      "IETF language tag": "de-LU",
      "flag code": "lu Luxembourg"
    },
    {
      "Culture .NET": "dsb-DE",
      "English": "Lower Sorbian (Germany)",
      "Native": "dolnoserbšćina (Nimska)",
      "Two letter": "dsb",
      "Three letter": "dsb",
      "Three letter language name": "DSB",
      "LCID": 2094,
      "IETF language tag": "dsb-DE",
      "flag code": "de Germany"
    },
    {
      "Culture .NET": "dv",
      "English": "Divehi",
      "Native": "ދިވެހިބަސް",
      "Two letter": "dv",
      "Three letter": "div",
      "Three letter language name": "DIV",
      "LCID": 101,
      "IETF language tag": "dv",
      "flag code": ""
    },
    {
      "Culture .NET": "dv-MV",
      "English": "Divehi (Maldives)",
      "Native": "ދިވެހިބަސް (ދިވެހި ރާއްޖެ)",
      "Two letter": "dv",
      "Three letter": "div",
      "Three letter language name": "DIV",
      "LCID": 1125,
      "IETF language tag": "dv-MV",
      "flag code": "mv Maldives"
    },
    {
      "Culture .NET": "el",
      "English": "Greek",
      "Native": "ελληνικά",
      "Two letter": "el",
      "Three letter": "ell",
      "Three letter language name": "ELL",
      "LCID": 8,
      "IETF language tag": "el",
      "flag code": ""
    },
    {
      "Culture .NET": "el-GR",
      "English": "Greek (Greece)",
      "Native": "ελληνικά (Ελλάδα)",
      "Two letter": "el",
      "Three letter": "ell",
      "Three letter language name": "ELL",
      "LCID": 1032,
      "IETF language tag": "el-GR",
      "flag code": "gr Greece"
    },
    {
      "Culture .NET": "en",
      "English": "English",
      "Native": "English",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENU",
      "LCID": 9,
      "IETF language tag": "en",
      "flag code": ""
    },
    {
      "Culture .NET": "en-029",
      "English": "English (Caribbean)",
      "Native": "English (Caribbean)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENB",
      "LCID": 9225,
      "IETF language tag": "en-029",
      "flag code": ""
    },
    {
      "Culture .NET": "en-AU",
      "English": "English (Australia)",
      "Native": "English (Australia)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENA",
      "LCID": 3081,
      "IETF language tag": "en-AU",
      "flag code": "au Australia"
    },
    {
      "Culture .NET": "en-BZ",
      "English": "English (Belize)",
      "Native": "English (Belize)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENL",
      "LCID": 10249,
      "IETF language tag": "en-BZ",
      "flag code": "bz Belize"
    },
    {
      "Culture .NET": "en-CA",
      "English": "English (Canada)",
      "Native": "English (Canada)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENC",
      "LCID": 4105,
      "IETF language tag": "en-CA",
      "flag code": "ca Canada"
    },
    {
      "Culture .NET": "en-GB",
      "English": "English (United Kingdom)",
      "Native": "English (United Kingdom)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENG",
      "LCID": 2057,
      "IETF language tag": "en-GB",
      "flag code": "gb United Kingdom"
    },
    {
      "Culture .NET": "en-IE",
      "English": "English (Ireland)",
      "Native": "English (Eire)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENI",
      "LCID": 6153,
      "IETF language tag": "en-IE",
      "flag code": "ie Ireland"
    },
    {
      "Culture .NET": "en-IN",
      "English": "English (India)",
      "Native": "English (India)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENN",
      "LCID": 16393,
      "IETF language tag": "en-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "en-JM",
      "English": "English (Jamaica)",
      "Native": "English (Jamaica)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENJ",
      "LCID": 8201,
      "IETF language tag": "en-JM",
      "flag code": "jm Jamaica"
    },
    {
      "Culture .NET": "en-MY",
      "English": "English (Malaysia)",
      "Native": "English (Malaysia)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENM",
      "LCID": 17417,
      "IETF language tag": "en-MY",
      "flag code": "my Malaysia"
    },
    {
      "Culture .NET": "en-NZ",
      "English": "English (New Zealand)",
      "Native": "English (New Zealand)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENZ",
      "LCID": 5129,
      "IETF language tag": "en-NZ",
      "flag code": "nz New Zealand"
    },
    {
      "Culture .NET": "en-PH",
      "English": "English (Republic of the Philippines)",
      "Native": "English (Philippines)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENP",
      "LCID": 13321,
      "IETF language tag": "en-PH",
      "flag code": "ph Republic of the Philippines"
    },
    {
      "Culture .NET": "en-SG",
      "English": "English (Singapore)",
      "Native": "English (Singapore)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENE",
      "LCID": 18441,
      "IETF language tag": "en-SG",
      "flag code": "sg Singapore"
    },
    {
      "Culture .NET": "en-TT",
      "English": "English (Trinidad and Tobago)",
      "Native": "English (Trinidad y Tobago)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENT",
      "LCID": 11273,
      "IETF language tag": "en-TT",
      "flag code": "tt Trinidad and Tobago"
    },
    {
      "Culture .NET": "en-US",
      "English": "English (United States)",
      "Native": "English (United States)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENU",
      "LCID": 1033,
      "IETF language tag": "en-US",
      "flag code": "us United States"
    },
    {
      "Culture .NET": "en-ZA",
      "English": "English (South Africa)",
      "Native": "English (South Africa)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENS",
      "LCID": 7177,
      "IETF language tag": "en-ZA",
      "flag code": "za South Africa"
    },
    {
      "Culture .NET": "en-ZW",
      "English": "English (Zimbabwe)",
      "Native": "English (Zimbabwe)",
      "Two letter": "en",
      "Three letter": "eng",
      "Three letter language name": "ENW",
      "LCID": 12297,
      "IETF language tag": "en-ZW",
      "flag code": "zw Zimbabwe"
    },
    {
      "Culture .NET": "es",
      "English": "Spanish",
      "Native": "español",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESP",
      "LCID": 10,
      "IETF language tag": "es",
      "flag code": ""
    },
    {
      "Culture .NET": "es-AR",
      "English": "Spanish (Argentina)",
      "Native": "Español (Argentina)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESS",
      "LCID": 11274,
      "IETF language tag": "es-AR",
      "flag code": "ar Argentina"
    },
    {
      "Culture .NET": "es-BO",
      "English": "Spanish (Bolivia)",
      "Native": "Español (Bolivia)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESB",
      "LCID": 16394,
      "IETF language tag": "es-BO",
      "flag code": "bo Bolivia"
    },
    {
      "Culture .NET": "es-CL",
      "English": "Spanish (Chile)",
      "Native": "Español (Chile)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESL",
      "LCID": 13322,
      "IETF language tag": "es-CL",
      "flag code": "cl Chile"
    },
    {
      "Culture .NET": "es-CO",
      "English": "Spanish (Colombia)",
      "Native": "Español (Colombia)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESO",
      "LCID": 9226,
      "IETF language tag": "es-CO",
      "flag code": "co Colombia"
    },
    {
      "Culture .NET": "es-CR",
      "English": "Spanish (Costa Rica)",
      "Native": "Español (Costa Rica)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESC",
      "LCID": 5130,
      "IETF language tag": "es-CR",
      "flag code": "cr Costa Rica"
    },
    {
      "Culture .NET": "es-DO",
      "English": "Spanish (Dominican Republic)",
      "Native": "Español (República Dominicana)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESD",
      "LCID": 7178,
      "IETF language tag": "es-DO",
      "flag code": "do Dominican Republic"
    },
    {
      "Culture .NET": "es-EC",
      "English": "Spanish (Ecuador)",
      "Native": "Español (Ecuador)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESF",
      "LCID": 12298,
      "IETF language tag": "es-EC",
      "flag code": "ec Ecuador"
    },
    {
      "Culture .NET": "es-ES",
      "English": "Spanish (Spain)",
      "Native": "español (España)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESN",
      "LCID": 3082,
      "IETF language tag": "es-ES",
      "flag code": "es Spain"
    },
    {
      "Culture .NET": "es-GT",
      "English": "Spanish (Guatemala)",
      "Native": "Español (Guatemala)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESG",
      "LCID": 4106,
      "IETF language tag": "es-GT",
      "flag code": "gt Guatemala"
    },
    {
      "Culture .NET": "es-HN",
      "English": "Spanish (Honduras)",
      "Native": "Español (Honduras)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESH",
      "LCID": 18442,
      "IETF language tag": "es-HN",
      "flag code": "hn Honduras"
    },
    {
      "Culture .NET": "es-MX",
      "English": "Spanish (Mexico)",
      "Native": "Español (México)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESM",
      "LCID": 2058,
      "IETF language tag": "es-MX",
      "flag code": "mx Mexico"
    },
    {
      "Culture .NET": "es-NI",
      "English": "Spanish (Nicaragua)",
      "Native": "Español (Nicaragua)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESI",
      "LCID": 19466,
      "IETF language tag": "es-NI",
      "flag code": "ni Nicaragua"
    },
    {
      "Culture .NET": "es-PA",
      "English": "Spanish (Panama)",
      "Native": "Español (Panamá)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESA",
      "LCID": 6154,
      "IETF language tag": "es-PA",
      "flag code": "pa Panama"
    },
    {
      "Culture .NET": "es-PE",
      "English": "Spanish (Peru)",
      "Native": "Español (Perú)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESR",
      "LCID": 10250,
      "IETF language tag": "es-PE",
      "flag code": "pe Peru"
    },
    {
      "Culture .NET": "es-PR",
      "English": "Spanish (Puerto Rico)",
      "Native": "Español (Puerto Rico)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESU",
      "LCID": 20490,
      "IETF language tag": "es-PR",
      "flag code": "pr Puerto Rico"
    },
    {
      "Culture .NET": "es-PY",
      "English": "Spanish (Paraguay)",
      "Native": "Español (Paraguay)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESZ",
      "LCID": 15370,
      "IETF language tag": "es-PY",
      "flag code": "py Paraguay"
    },
    {
      "Culture .NET": "es-SV",
      "English": "Spanish (El Salvador)",
      "Native": "Español (El Salvador)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESE",
      "LCID": 17418,
      "IETF language tag": "es-SV",
      "flag code": "sv El Salvador"
    },
    {
      "Culture .NET": "es-US",
      "English": "Spanish (United States)",
      "Native": "Español (Estados Unidos)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "EST",
      "LCID": 21514,
      "IETF language tag": "es-US",
      "flag code": "us United States"
    },
    {
      "Culture .NET": "es-UY",
      "English": "Spanish (Uruguay)",
      "Native": "Español (Uruguay)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESY",
      "LCID": 14346,
      "IETF language tag": "es-UY",
      "flag code": "uy Uruguay"
    },
    {
      "Culture .NET": "es-VE",
      "English": "Spanish (Venezuela)",
      "Native": "Español (Republica Bolivariana de Venezuela)",
      "Two letter": "es",
      "Three letter": "spa",
      "Three letter language name": "ESV",
      "LCID": 8202,
      "IETF language tag": "es-VE",
      "flag code": "ve Venezuela"
    },
    {
      "Culture .NET": "et",
      "English": "Estonian",
      "Native": "eesti",
      "Two letter": "et",
      "Three letter": "est",
      "Three letter language name": "ETI",
      "LCID": 37,
      "IETF language tag": "et",
      "flag code": ""
    },
    {
      "Culture .NET": "et-EE",
      "English": "Estonian (Estonia)",
      "Native": "eesti (Eesti)",
      "Two letter": "et",
      "Three letter": "est",
      "Three letter language name": "ETI",
      "LCID": 1061,
      "IETF language tag": "et-EE",
      "flag code": "ee Estonia"
    },
    {
      "Culture .NET": "eu",
      "English": "Basque",
      "Native": "euskara",
      "Two letter": "eu",
      "Three letter": "eus",
      "Three letter language name": "EUQ",
      "LCID": 45,
      "IETF language tag": "eu",
      "flag code": ""
    },
    {
      "Culture .NET": "eu-ES",
      "English": "Basque (Basque)",
      "Native": "euskara (euskara)",
      "Two letter": "eu",
      "Three letter": "eus",
      "Three letter language name": "EUQ",
      "LCID": 1069,
      "IETF language tag": "eu-ES",
      "flag code": "es Basque"
    },
    {
      "Culture .NET": "fa",
      "English": "Persian",
      "Native": "فارسى",
      "Two letter": "fa",
      "Three letter": "fas",
      "Three letter language name": "FAR",
      "LCID": 41,
      "IETF language tag": "fa",
      "flag code": ""
    },
    {
      "Culture .NET": "fa-IR",
      "English": "Persian (Iran)",
      "Native": "فارسى (ايران)",
      "Two letter": "fa",
      "Three letter": "fas",
      "Three letter language name": "FAR",
      "LCID": 1065,
      "IETF language tag": "fa-IR",
      "flag code": "ir Iran"
    },
    {
      "Culture .NET": "fi",
      "English": "Finnish",
      "Native": "suomi",
      "Two letter": "fi",
      "Three letter": "fin",
      "Three letter language name": "FIN",
      "LCID": 11,
      "IETF language tag": "fi",
      "flag code": ""
    },
    {
      "Culture .NET": "fi-FI",
      "English": "Finnish (Finland)",
      "Native": "suomi (Suomi)",
      "Two letter": "fi",
      "Three letter": "fin",
      "Three letter language name": "FIN",
      "LCID": 1035,
      "IETF language tag": "fi-FI",
      "flag code": "fi Finland"
    },
    {
      "Culture .NET": "fil-PH",
      "English": "Filipino (Philippines)",
      "Native": "Filipino (Pilipinas)",
      "Two letter": "fil",
      "Three letter": "fil",
      "Three letter language name": "FPO",
      "LCID": 1124,
      "IETF language tag": "fil-PH",
      "flag code": "ph Philippines"
    },
    {
      "Culture .NET": "fo",
      "English": "Faroese",
      "Native": "føroyskt",
      "Two letter": "fo",
      "Three letter": "fao",
      "Three letter language name": "FOS",
      "LCID": 56,
      "IETF language tag": "fo",
      "flag code": ""
    },
    {
      "Culture .NET": "fo-FO",
      "English": "Faroese (Faroe Islands)",
      "Native": "føroyskt (Føroyar)",
      "Two letter": "fo",
      "Three letter": "fao",
      "Three letter language name": "FOS",
      "LCID": 1080,
      "IETF language tag": "fo-FO",
      "flag code": "fo Faroe Islands"
    },
    {
      "Culture .NET": "fr",
      "English": "French",
      "Native": "français",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRA",
      "LCID": 12,
      "IETF language tag": "fr",
      "flag code": ""
    },
    {
      "Culture .NET": "fr-BE",
      "English": "French (Belgium)",
      "Native": "français (Belgique)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRB",
      "LCID": 2060,
      "IETF language tag": "fr-BE",
      "flag code": "be Belgium"
    },
    {
      "Culture .NET": "fr-CA",
      "English": "French (Canada)",
      "Native": "français (Canada)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRC",
      "LCID": 3084,
      "IETF language tag": "fr-CA",
      "flag code": "ca Canada"
    },
    {
      "Culture .NET": "fr-CH",
      "English": "French (Switzerland)",
      "Native": "français (Suisse)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRS",
      "LCID": 4108,
      "IETF language tag": "fr-CH",
      "flag code": "ch Switzerland"
    },
    {
      "Culture .NET": "fr-FR",
      "English": "French (France)",
      "Native": "français (France)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRA",
      "LCID": 1036,
      "IETF language tag": "fr-FR",
      "flag code": "fr France"
    },
    {
      "Culture .NET": "fr-LU",
      "English": "French (Luxembourg)",
      "Native": "français (Luxembourg)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRL",
      "LCID": 5132,
      "IETF language tag": "fr-LU",
      "flag code": "lu Luxembourg"
    },
    {
      "Culture .NET": "fr-MC",
      "English": "French (Principality of Monaco)",
      "Native": "français (Principauté de Monaco)",
      "Two letter": "fr",
      "Three letter": "fra",
      "Three letter language name": "FRM",
      "LCID": 6156,
      "IETF language tag": "fr-MC",
      "flag code": "mc Principality of Monaco"
    },
    {
      "Culture .NET": "fy-NL",
      "English": "Frisian (Netherlands)",
      "Native": "Frysk (Nederlân)",
      "Two letter": "fy",
      "Three letter": "fry",
      "Three letter language name": "FYN",
      "LCID": 1122,
      "IETF language tag": "fy-NL",
      "flag code": "nl Netherlands"
    },
    {
      "Culture .NET": "ga-IE",
      "English": "Irish (Ireland)",
      "Native": "Gaeilge (Éire)",
      "Two letter": "ga",
      "Three letter": "gle",
      "Three letter language name": "IRE",
      "LCID": 2108,
      "IETF language tag": "ga-IE",
      "flag code": "ie Ireland"
    },
    {
      "Culture .NET": "gd-GB",
      "English": "Scottish Gaelic (United Kingdom)",
      "Native": "Gàidhlig (An Rìoghachd Aonaichte)",
      "Two letter": "gd",
      "Three letter": "gla",
      "Three letter language name": "GLA",
      "LCID": 1169,
      "IETF language tag": "gd-GB",
      "flag code": "gb United Kingdom"
    },
    {
      "Culture .NET": "gl",
      "English": "Galician",
      "Native": "galego",
      "Two letter": "gl",
      "Three letter": "glg",
      "Three letter language name": "GLC",
      "LCID": 86,
      "IETF language tag": "gl",
      "flag code": ""
    },
    {
      "Culture .NET": "gl-ES",
      "English": "Galician (Galician)",
      "Native": "galego (galego)",
      "Two letter": "gl",
      "Three letter": "glg",
      "Three letter language name": "GLC",
      "LCID": 1110,
      "IETF language tag": "gl-ES",
      "flag code": "es Galician"
    },
    {
      "Culture .NET": "gsw-FR",
      "English": "Alsatian (France)",
      "Native": "Elsässisch (Frànkrisch)",
      "Two letter": "gsw",
      "Three letter": "gsw",
      "Three letter language name": "GSW",
      "LCID": 1156,
      "IETF language tag": "gsw-FR",
      "flag code": "fr France"
    },
    {
      "Culture .NET": "gu",
      "English": "Gujarati",
      "Native": "ગુજરાતી",
      "Two letter": "gu",
      "Three letter": "guj",
      "Three letter language name": "GUJ",
      "LCID": 71,
      "IETF language tag": "gu",
      "flag code": ""
    },
    {
      "Culture .NET": "gu-IN",
      "English": "Gujarati (India)",
      "Native": "ગુજરાતી (ભારત)",
      "Two letter": "gu",
      "Three letter": "guj",
      "Three letter language name": "GUJ",
      "LCID": 1095,
      "IETF language tag": "gu-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "ha-Latn-NG",
      "English": "Hausa (Latin) (Nigeria)",
      "Native": "Hausa (Nigeria)",
      "Two letter": "ha",
      "Three letter": "hau",
      "Three letter language name": "HAU",
      "LCID": 1128,
      "IETF language tag": "ha-Latn-NG",
      "flag code": "ng Nigeria"
    },
    {
      "Culture .NET": "he",
      "English": "Hebrew",
      "Native": "עברית",
      "Two letter": "he",
      "Three letter": "heb",
      "Three letter language name": "HEB",
      "LCID": 13,
      "IETF language tag": "he",
      "flag code": ""
    },
    {
      "Culture .NET": "he-IL",
      "English": "Hebrew (Israel)",
      "Native": "עברית (ישראל)",
      "Two letter": "he",
      "Three letter": "heb",
      "Three letter language name": "HEB",
      "LCID": 1037,
      "IETF language tag": "he-IL",
      "flag code": "il Israel"
    },
    {
      "Culture .NET": "hi",
      "English": "Hindi",
      "Native": "हिंदी",
      "Two letter": "hi",
      "Three letter": "hin",
      "Three letter language name": "HIN",
      "LCID": 57,
      "IETF language tag": "hi",
      "flag code": ""
    },
    {
      "Culture .NET": "hi-IN",
      "English": "Hindi (India)",
      "Native": "हिंदी (भारत)",
      "Two letter": "hi",
      "Three letter": "hin",
      "Three letter language name": "HIN",
      "LCID": 1081,
      "IETF language tag": "hi-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "hr",
      "English": "Croatian",
      "Native": "hrvatski",
      "Two letter": "hr",
      "Three letter": "hrv",
      "Three letter language name": "HRV",
      "LCID": 26,
      "IETF language tag": "hr",
      "flag code": ""
    },
    {
      "Culture .NET": "hr-BA",
      "English": "Croatian (Latin) (Bosnia and Herzegovina)",
      "Native": "hrvatski (Bosna i Hercegovina)",
      "Two letter": "hr",
      "Three letter": "hrb",
      "Three letter language name": "HRB",
      "LCID": 4122,
      "IETF language tag": "hr-BA",
      "flag code": "ba Bosnia and Herzegovina"
    },
    {
      "Culture .NET": "hr-HR",
      "English": "Croatian (Croatia)",
      "Native": "hrvatski (Hrvatska)",
      "Two letter": "hr",
      "Three letter": "hrv",
      "Three letter language name": "HRV",
      "LCID": 1050,
      "IETF language tag": "hr-HR",
      "flag code": "hr Croatia"
    },
    {
      "Culture .NET": "hsb-DE",
      "English": "Upper Sorbian (Germany)",
      "Native": "hornjoserbšćina (Němska)",
      "Two letter": "hsb",
      "Three letter": "hsb",
      "Three letter language name": "HSB",
      "LCID": 1070,
      "IETF language tag": "hsb-DE",
      "flag code": "de Germany"
    },
    {
      "Culture .NET": "hu",
      "English": "Hungarian",
      "Native": "magyar",
      "Two letter": "hu",
      "Three letter": "hun",
      "Three letter language name": "HUN",
      "LCID": 14,
      "IETF language tag": "hu",
      "flag code": ""
    },
    {
      "Culture .NET": "hu-HU",
      "English": "Hungarian (Hungary)",
      "Native": "magyar (Magyarország)",
      "Two letter": "hu",
      "Three letter": "hun",
      "Three letter language name": "HUN",
      "LCID": 1038,
      "IETF language tag": "hu-HU",
      "flag code": "hu Hungary"
    },
    {
      "Culture .NET": "hy",
      "English": "Armenian",
      "Native": "Հայերեն",
      "Two letter": "hy",
      "Three letter": "hye",
      "Three letter language name": "HYE",
      "LCID": 43,
      "IETF language tag": "hy",
      "flag code": ""
    },
    {
      "Culture .NET": "hy-AM",
      "English": "Armenian (Armenia)",
      "Native": "Հայերեն (Հայաստան)",
      "Two letter": "hy",
      "Three letter": "hye",
      "Three letter language name": "HYE",
      "LCID": 1067,
      "IETF language tag": "hy-AM",
      "flag code": "am Armenia"
    },
    {
      "Culture .NET": "id",
      "English": "Indonesian",
      "Native": "Bahasa Indonesia",
      "Two letter": "id",
      "Three letter": "ind",
      "Three letter language name": "IND",
      "LCID": 33,
      "IETF language tag": "id",
      "flag code": ""
    },
    {
      "Culture .NET": "id-ID",
      "English": "Indonesian (Indonesia)",
      "Native": "Bahasa Indonesia (Indonesia)",
      "Two letter": "id",
      "Three letter": "ind",
      "Three letter language name": "IND",
      "LCID": 1057,
      "IETF language tag": "id-ID",
      "flag code": "id Indonesia"
    },
    {
      "Culture .NET": "ig-NG",
      "English": "Igbo (Nigeria)",
      "Native": "Igbo (Nigeria)",
      "Two letter": "ig",
      "Three letter": "ibo",
      "Three letter language name": "IBO",
      "LCID": 1136,
      "IETF language tag": "ig-NG",
      "flag code": "ng Nigeria"
    },
    {
      "Culture .NET": "ii-CN",
      "English": "Yi (People's Republic of China)",
      "Native": "ꆈꌠꁱꂷ (ꍏꉸꏓꂱꇭꉼꇩ)",
      "Two letter": "ii",
      "Three letter": "iii",
      "Three letter language name": "III",
      "LCID": 1144,
      "IETF language tag": "ii-CN",
      "flag code": "cn People's Republic of China"
    },
    {
      "Culture .NET": "is",
      "English": "Icelandic",
      "Native": "íslenska",
      "Two letter": "is",
      "Three letter": "isl",
      "Three letter language name": "ISL",
      "LCID": 15,
      "IETF language tag": "is",
      "flag code": ""
    },
    {
      "Culture .NET": "is-IS",
      "English": "Icelandic (Iceland)",
      "Native": "íslenska (Ísland)",
      "Two letter": "is",
      "Three letter": "isl",
      "Three letter language name": "ISL",
      "LCID": 1039,
      "IETF language tag": "is-IS",
      "flag code": "is Iceland"
    },
    {
      "Culture .NET": "it",
      "English": "Italian",
      "Native": "italiano",
      "Two letter": "it",
      "Three letter": "ita",
      "Three letter language name": "ITA",
      "LCID": 16,
      "IETF language tag": "it",
      "flag code": ""
    },
    {
      "Culture .NET": "it-CH",
      "English": "Italian (Switzerland)",
      "Native": "italiano (Svizzera)",
      "Two letter": "it",
      "Three letter": "ita",
      "Three letter language name": "ITS",
      "LCID": 2064,
      "IETF language tag": "it-CH",
      "flag code": "ch Switzerland"
    },
    {
      "Culture .NET": "it-IT",
      "English": "Italian (Italy)",
      "Native": "italiano (Italia)",
      "Two letter": "it",
      "Three letter": "ita",
      "Three letter language name": "ITA",
      "LCID": 1040,
      "IETF language tag": "it-IT",
      "flag code": "it Italy"
    },
    {
      "Culture .NET": "iu-Cans-CA",
      "English": "Inuktitut (Syllabics) (Canada)",
      "Native": "ᐃᓄᒃᑎᑐᑦ (ᑲᓇᑕ)",
      "Two letter": "iu",
      "Three letter": "iku",
      "Three letter language name": "IUS",
      "LCID": 1117,
      "IETF language tag": "iu-Cans-CA",
      "flag code": "ca Canada"
    },
    {
      "Culture .NET": "iu-Latn-CA",
      "English": "Inuktitut (Latin) (Canada)",
      "Native": "Inuktitut (kanata)",
      "Two letter": "iu",
      "Three letter": "iku",
      "Three letter language name": "IUK",
      "LCID": 2141,
      "IETF language tag": "iu-Latn-CA",
      "flag code": "ca Canada"
    },
    {
      "Culture .NET": "ja",
      "English": "Japanese",
      "Native": "日本語",
      "Two letter": "ja",
      "Three letter": "jpn",
      "Three letter language name": "JPN",
      "LCID": 17,
      "IETF language tag": "ja",
      "flag code": ""
    },
    {
      "Culture .NET": "ja-JP",
      "English": "Japanese (Japan)",
      "Native": "日本語 (日本)",
      "Two letter": "ja",
      "Three letter": "jpn",
      "Three letter language name": "JPN",
      "LCID": 1041,
      "IETF language tag": "ja-JP",
      "flag code": "jp Japan"
    },
    {
      "Culture .NET": "ka",
      "English": "Georgian",
      "Native": "ქართული",
      "Two letter": "ka",
      "Three letter": "kat",
      "Three letter language name": "KAT",
      "LCID": 55,
      "IETF language tag": "ka",
      "flag code": ""
    },
    {
      "Culture .NET": "ka-GE",
      "English": "Georgian (Georgia)",
      "Native": "ქართული (საქართველო)",
      "Two letter": "ka",
      "Three letter": "kat",
      "Three letter language name": "KAT",
      "LCID": 1079,
      "IETF language tag": "ka-GE",
      "flag code": "ge Georgia"
    },
    {
      "Culture .NET": "kk",
      "English": "Kazakh",
      "Native": "Қазащb",
      "Two letter": "kk",
      "Three letter": "kaz",
      "Three letter language name": "KKZ",
      "LCID": 63,
      "IETF language tag": "kk",
      "flag code": ""
    },
    {
      "Culture .NET": "kk-KZ",
      "English": "Kazakh (Kazakhstan)",
      "Native": "Қазақ (Қазақстан)",
      "Two letter": "kk",
      "Three letter": "kaz",
      "Three letter language name": "KKZ",
      "LCID": 1087,
      "IETF language tag": "kk-KZ",
      "flag code": "kz Kazakhstan"
    },
    {
      "Culture .NET": "kl-GL",
      "English": "Greenlandic (Greenland)",
      "Native": "kalaallisut (Kalaallit Nunaat)",
      "Two letter": "kl",
      "Three letter": "kal",
      "Three letter language name": "KAL",
      "LCID": 1135,
      "IETF language tag": "kl-GL",
      "flag code": "gl Greenland"
    },
    {
      "Culture .NET": "km-KH",
      "English": "Khmer (Cambodia)",
      "Native": "ខ្មែរ (កម្ពុជា)",
      "Two letter": "km",
      "Three letter": "khm",
      "Three letter language name": "KHM",
      "LCID": 1107,
      "IETF language tag": "km-KH",
      "flag code": "kh Cambodia"
    },
    {
      "Culture .NET": "kn",
      "English": "Kannada",
      "Native": "ಕನ್ನಡ",
      "Two letter": "kn",
      "Three letter": "kan",
      "Three letter language name": "KDI",
      "LCID": 75,
      "IETF language tag": "kn",
      "flag code": ""
    },
    {
      "Culture .NET": "kn-IN",
      "English": "Kannada (India)",
      "Native": "ಕನ್ನಡ (ಭಾರತ)",
      "Two letter": "kn",
      "Three letter": "kan",
      "Three letter language name": "KDI",
      "LCID": 1099,
      "IETF language tag": "kn-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "ko",
      "English": "Korean",
      "Native": "한국어",
      "Two letter": "ko",
      "Three letter": "kor",
      "Three letter language name": "KOR",
      "LCID": 18,
      "IETF language tag": "ko",
      "flag code": ""
    },
    {
      "Culture .NET": "ko-KR",
      "English": "Korean (Korea)",
      "Native": "한국어 (대한민국)",
      "Two letter": "ko",
      "Three letter": "kor",
      "Three letter language name": "KOR",
      "LCID": 1042,
      "IETF language tag": "ko-KR",
      "flag code": "kr Korea"
    },
    {
      "Culture .NET": "kok",
      "English": "Konkani",
      "Native": "कोंकणी",
      "Two letter": "kok",
      "Three letter": "kok",
      "Three letter language name": "KNK",
      "LCID": 87,
      "IETF language tag": "kok",
      "flag code": ""
    },
    {
      "Culture .NET": "kok-IN",
      "English": "Konkani (India)",
      "Native": "कोंकणी (भारत)",
      "Two letter": "kok",
      "Three letter": "kok",
      "Three letter language name": "KNK",
      "LCID": 1111,
      "IETF language tag": "kok-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "ky",
      "English": "Kyrgyz",
      "Native": "Кыргыз",
      "Two letter": "ky",
      "Three letter": "kir",
      "Three letter language name": "KYR",
      "LCID": 64,
      "IETF language tag": "ky",
      "flag code": ""
    },
    {
      "Culture .NET": "ky-KG",
      "English": "Kyrgyz (Kyrgyzstan)",
      "Native": "Кыргыз (Кыргызстан)",
      "Two letter": "ky",
      "Three letter": "kir",
      "Three letter language name": "KYR",
      "LCID": 1088,
      "IETF language tag": "ky-KG",
      "flag code": "kg Kyrgyzstan"
    },
    {
      "Culture .NET": "lb-LU",
      "English": "Luxembourgish (Luxembourg)",
      "Native": "Lëtzebuergesch (Luxembourg)",
      "Two letter": "lb",
      "Three letter": "ltz",
      "Three letter language name": "LBX",
      "LCID": 1134,
      "IETF language tag": "lb-LU",
      "flag code": "lu Luxembourg"
    },
    {
      "Culture .NET": "lo-LA",
      "English": "Lao (Lao P.D.R.)",
      "Native": "ລາວ (ສ.ປ.ປ. ລາວ)",
      "Two letter": "lo",
      "Three letter": "lao",
      "Three letter language name": "LAO",
      "LCID": 1108,
      "IETF language tag": "lo-LA",
      "flag code": "la Lao P.D.R."
    },
    {
      "Culture .NET": "lt",
      "English": "Lithuanian",
      "Native": "lietuvių",
      "Two letter": "lt",
      "Three letter": "lit",
      "Three letter language name": "LTH",
      "LCID": 39,
      "IETF language tag": "lt",
      "flag code": ""
    },
    {
      "Culture .NET": "lt-LT",
      "English": "Lithuanian (Lithuania)",
      "Native": "lietuvių (Lietuva)",
      "Two letter": "lt",
      "Three letter": "lit",
      "Three letter language name": "LTH",
      "LCID": 1063,
      "IETF language tag": "lt-LT",
      "flag code": "lt Lithuania"
    },
    {
      "Culture .NET": "lv",
      "English": "Latvian",
      "Native": "latviešu",
      "Two letter": "lv",
      "Three letter": "lav",
      "Three letter language name": "LVI",
      "LCID": 38,
      "IETF language tag": "lv",
      "flag code": ""
    },
    {
      "Culture .NET": "lv-LV",
      "English": "Latvian (Latvia)",
      "Native": "latviešu (Latvija)",
      "Two letter": "lv",
      "Three letter": "lav",
      "Three letter language name": "LVI",
      "LCID": 1062,
      "IETF language tag": "lv-LV",
      "flag code": "lv Latvia"
    },
    {
      "Culture .NET": "mi-NZ",
      "English": "Maori (New Zealand)",
      "Native": "Reo Māori (Aotearoa)",
      "Two letter": "mi",
      "Three letter": "mri",
      "Three letter language name": "MRI",
      "LCID": 1153,
      "IETF language tag": "mi-NZ",
      "flag code": "nz New Zealand"
    },
    {
      "Culture .NET": "mk",
      "English": "Macedonian",
      "Native": "македонски јазик",
      "Two letter": "mk",
      "Three letter": "mkd",
      "Three letter language name": "MKI",
      "LCID": 47,
      "IETF language tag": "mk",
      "flag code": ""
    },
    {
      "Culture .NET": "mk-MK",
      "English": "Macedonian (Former Yugoslav Republic of Macedonia)",
      "Native": "македонски јазик (Македонија)",
      "Two letter": "mk",
      "Three letter": "mkd",
      "Three letter language name": "MKI",
      "LCID": 1071,
      "IETF language tag": "mk-MK",
      "flag code": "mk Former Yugoslav Republic of Macedonia"
    },
    {
      "Culture .NET": "ml-IN",
      "English": "Malayalam (India)",
      "Native": "മലയാളം (ഭാരതം)",
      "Two letter": "ml",
      "Three letter": "mym",
      "Three letter language name": "MYM",
      "LCID": 1100,
      "IETF language tag": "ml-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "mn",
      "English": "Mongolian",
      "Native": "Монгол хэл",
      "Two letter": "mn",
      "Three letter": "mon",
      "Three letter language name": "MON",
      "LCID": 80,
      "IETF language tag": "mn",
      "flag code": ""
    },
    {
      "Culture .NET": "mn-MN",
      "English": "Mongolian (Cyrillic) (Mongolia)",
      "Native": "Монгол хэл (Монгол улс)",
      "Two letter": "mn",
      "Three letter": "mon",
      "Three letter language name": "MON",
      "LCID": 1104,
      "IETF language tag": "mn-MN",
      "flag code": "mn Mongolia"
    },
    {
      "Culture .NET": "mn-Mong-CN",
      "English": "Mongolian (Traditional Mongolian) (People's Republic of China)",
      "Native": "ᠮᠤᠨᠭᠭᠤᠯ ᠬᠡᠯᠡ (ᠪᠦᠭᠦᠳᠡ ᠨᠠᠢᠷᠠᠮᠳᠠᠬᠤ ᠳᠤᠮᠳᠠᠳᠤ ᠠᠷᠠᠳ ᠣᠯᠣᠰ)",
      "Two letter": "mn",
      "Three letter": "mon",
      "Three letter language name": "MNG",
      "LCID": 2128,
      "IETF language tag": "mn-Mong-CN",
      "flag code": "cn People's Republic of China"
    },
    {
      "Culture .NET": "moh-CA",
      "English": "Mohawk (Canada)",
      "Native": "Kanien'kéha (Canada)",
      "Two letter": "moh",
      "Three letter": "moh",
      "Three letter language name": "MWK",
      "LCID": 1148,
      "IETF language tag": "moh-CA",
      "flag code": "ca Canada"
    },
    {
      "Culture .NET": "mr",
      "English": "Marathi",
      "Native": "मराठी",
      "Two letter": "mr",
      "Three letter": "mar",
      "Three letter language name": "MAR",
      "LCID": 78,
      "IETF language tag": "mr",
      "flag code": ""
    },
    {
      "Culture .NET": "mr-IN",
      "English": "Marathi (India)",
      "Native": "मराठी (भारत)",
      "Two letter": "mr",
      "Three letter": "mar",
      "Three letter language name": "MAR",
      "LCID": 1102,
      "IETF language tag": "mr-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "ms",
      "English": "Malay",
      "Native": "Bahasa Malaysia",
      "Two letter": "ms",
      "Three letter": "msa",
      "Three letter language name": "MSL",
      "LCID": 62,
      "IETF language tag": "ms",
      "flag code": ""
    },
    {
      "Culture .NET": "ms-BN",
      "English": "Malay (Brunei Darussalam)",
      "Native": "Bahasa Malaysia (Brunei Darussalam)",
      "Two letter": "ms",
      "Three letter": "msa",
      "Three letter language name": "MSB",
      "LCID": 2110,
      "IETF language tag": "ms-BN",
      "flag code": "bn Brunei Darussalam"
    },
    {
      "Culture .NET": "ms-MY",
      "English": "Malay (Malaysia)",
      "Native": "Bahasa Malaysia (Malaysia)",
      "Two letter": "ms",
      "Three letter": "msa",
      "Three letter language name": "MSL",
      "LCID": 1086,
      "IETF language tag": "ms-MY",
      "flag code": "my Malaysia"
    },
    {
      "Culture .NET": "mt-MT",
      "English": "Maltese (Malta)",
      "Native": "Malti (Malta)",
      "Two letter": "mt",
      "Three letter": "mlt",
      "Three letter language name": "MLT",
      "LCID": 1082,
      "IETF language tag": "mt-MT",
      "flag code": "mt Malta"
    },
    {
      "Culture .NET": "nb-NO",
      "English": "Norwegian, Bokmål (Norway)",
      "Native": "norsk, bokmål (Norge)",
      "Two letter": "nb",
      "Three letter": "nob",
      "Three letter language name": "NOR",
      "LCID": 1044,
      "IETF language tag": "nb-NO",
      "flag code": "no Norway"
    },
    {
      "Culture .NET": "ne-NP",
      "English": "Nepali (Nepal)",
      "Native": "नेपाली (नेपाल)",
      "Two letter": "ne",
      "Three letter": "nep",
      "Three letter language name": "NEP",
      "LCID": 1121,
      "IETF language tag": "ne-NP",
      "flag code": "np Nepal"
    },
    {
      "Culture .NET": "nl",
      "English": "Dutch",
      "Native": "Nederlands",
      "Two letter": "nl",
      "Three letter": "nld",
      "Three letter language name": "NLD",
      "LCID": 19,
      "IETF language tag": "nl",
      "flag code": ""
    },
    {
      "Culture .NET": "nl-BE",
      "English": "Dutch (Belgium)",
      "Native": "Nederlands (België)",
      "Two letter": "nl",
      "Three letter": "nld",
      "Three letter language name": "NLB",
      "LCID": 2067,
      "IETF language tag": "nl-BE",
      "flag code": "be Belgium"
    },
    {
      "Culture .NET": "nl-NL",
      "English": "Dutch (Netherlands)",
      "Native": "Nederlands (Nederland)",
      "Two letter": "nl",
      "Three letter": "nld",
      "Three letter language name": "NLD",
      "LCID": 1043,
      "IETF language tag": "nl-NL",
      "flag code": "nl Netherlands"
    },
    {
      "Culture .NET": "nn-NO",
      "English": "Norwegian, Nynorsk (Norway)",
      "Native": "norsk, nynorsk (Noreg)",
      "Two letter": "nn",
      "Three letter": "nno",
      "Three letter language name": "NON",
      "LCID": 2068,
      "IETF language tag": "nn-NO",
      "flag code": "no Norway"
    },
    {
      "Culture .NET": "no",
      "English": "Norwegian",
      "Native": "norsk",
      "Two letter": "no",
      "Three letter": "nor",
      "Three letter language name": "NOR",
      "LCID": 20,
      "IETF language tag": "no",
      "flag code": "no"
    },
    {
      "Culture .NET": "nso-ZA",
      "English": "Sesotho sa Leboa (South Africa)",
      "Native": "Sesotho sa Leboa (Afrika Borwa)",
      "Two letter": "nso",
      "Three letter": "nso",
      "Three letter language name": "NSO",
      "LCID": 1132,
      "IETF language tag": "nso-ZA",
      "flag code": "za South Africa"
    },
    {
      "Culture .NET": "oc-FR",
      "English": "Occitan (France)",
      "Native": "Occitan (França)",
      "Two letter": "oc",
      "Three letter": "oci",
      "Three letter language name": "OCI",
      "LCID": 1154,
      "IETF language tag": "oc-FR",
      "flag code": "fr France"
    },
    {
      "Culture .NET": "or-IN",
      "English": "Oriya (India)",
      "Native": "ଓଡ଼ିଆ (ଭାରତ)",
      "Two letter": "or",
      "Three letter": "ori",
      "Three letter language name": "ORI",
      "LCID": 1096,
      "IETF language tag": "or-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "pa",
      "English": "Punjabi",
      "Native": "ਪੰਜਾਬੀ",
      "Two letter": "pa",
      "Three letter": "pan",
      "Three letter language name": "PAN",
      "LCID": 70,
      "IETF language tag": "pa",
      "flag code": ""
    },
    {
      "Culture .NET": "pa-IN",
      "English": "Punjabi (India)",
      "Native": "ਪੰਜਾਬੀ (ਭਾਰਤ)",
      "Two letter": "pa",
      "Three letter": "pan",
      "Three letter language name": "PAN",
      "LCID": 1094,
      "IETF language tag": "pa-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "pl",
      "English": "Polish",
      "Native": "polski",
      "Two letter": "pl",
      "Three letter": "pol",
      "Three letter language name": "PLK",
      "LCID": 21,
      "IETF language tag": "pl",
      "flag code": ""
    },
    {
      "Culture .NET": "pl-PL",
      "English": "Polish (Poland)",
      "Native": "polski (Polska)",
      "Two letter": "pl",
      "Three letter": "pol",
      "Three letter language name": "PLK",
      "LCID": 1045,
      "IETF language tag": "pl-PL",
      "flag code": "pl Poland"
    },
    {
      "Culture .NET": "prs-AF",
      "English": "Dari (Afghanistan)",
      "Native": "درى (افغانستان)",
      "Two letter": "prs",
      "Three letter": "prs",
      "Three letter language name": "PRS",
      "LCID": 1164,
      "IETF language tag": "prs-AF",
      "flag code": "af Afghanistan"
    },
    {
      "Culture .NET": "ps-AF",
      "English": "Pashto (Afghanistan)",
      "Native": "پښتو (افغانستان)",
      "Two letter": "ps",
      "Three letter": "pus",
      "Three letter language name": "PAS",
      "LCID": 1123,
      "IETF language tag": "ps-AF",
      "flag code": "af Afghanistan"
    },
    {
      "Culture .NET": "pt",
      "English": "Portuguese",
      "Native": "Português",
      "Two letter": "pt",
      "Three letter": "por",
      "Three letter language name": "PTB",
      "LCID": 22,
      "IETF language tag": "pt",
      "flag code": ""
    },
    {
      "Culture .NET": "pt-BR",
      "English": "Portuguese (Brazil)",
      "Native": "Português (Brasil)",
      "Two letter": "pt",
      "Three letter": "por",
      "Three letter language name": "PTB",
      "LCID": 1046,
      "IETF language tag": "pt-BR",
      "flag code": "br Brazil"
    },
    {
      "Culture .NET": "pt-PT",
      "English": "Portuguese (Portugal)",
      "Native": "português (Portugal)",
      "Two letter": "pt",
      "Three letter": "por",
      "Three letter language name": "PTG",
      "LCID": 2070,
      "IETF language tag": "pt-PT",
      "flag code": "pt Portugal"
    },
    {
      "Culture .NET": "qut-GT",
      "English": "K'iche (Guatemala)",
      "Native": "K'iche (Guatemala)",
      "Two letter": "qut",
      "Three letter": "qut",
      "Three letter language name": "QUT",
      "LCID": 1158,
      "IETF language tag": "qut-GT",
      "flag code": "gt Guatemala"
    },
    {
      "Culture .NET": "quz-BO",
      "English": "Quechua (Bolivia)",
      "Native": "runasimi (Bolivia Suyu)",
      "Two letter": "quz",
      "Three letter": "qub",
      "Three letter language name": "QUB",
      "LCID": 1131,
      "IETF language tag": "quz-BO",
      "flag code": "bo Bolivia"
    },
    {
      "Culture .NET": "quz-EC",
      "English": "Quechua (Ecuador)",
      "Native": "runasimi (Ecuador Suyu)",
      "Two letter": "quz",
      "Three letter": "que",
      "Three letter language name": "QUE",
      "LCID": 2155,
      "IETF language tag": "quz-EC",
      "flag code": "ec Ecuador"
    },
    {
      "Culture .NET": "quz-PE",
      "English": "Quechua (Peru)",
      "Native": "runasimi (Peru Suyu)",
      "Two letter": "quz",
      "Three letter": "qup",
      "Three letter language name": "QUP",
      "LCID": 3179,
      "IETF language tag": "quz-PE",
      "flag code": "pe Peru"
    },
    {
      "Culture .NET": "rm-CH",
      "English": "Romansh (Switzerland)",
      "Native": "Rumantsch (Svizra)",
      "Two letter": "rm",
      "Three letter": "roh",
      "Three letter language name": "RMC",
      "LCID": 1047,
      "IETF language tag": "rm-CH",
      "flag code": "ch Switzerland"
    },
    {
      "Culture .NET": "ro",
      "English": "Romanian",
      "Native": "română",
      "Two letter": "ro",
      "Three letter": "ron",
      "Three letter language name": "ROM",
      "LCID": 24,
      "IETF language tag": "ro",
      "flag code": ""
    },
    {
      "Culture .NET": "ro-RO",
      "English": "Romanian (Romania)",
      "Native": "română (România)",
      "Two letter": "ro",
      "Three letter": "ron",
      "Three letter language name": "ROM",
      "LCID": 1048,
      "IETF language tag": "ro-RO",
      "flag code": "ro Romania"
    },
    {
      "Culture .NET": "ru",
      "English": "Russian",
      "Native": "русский",
      "Two letter": "ru",
      "Three letter": "rus",
      "Three letter language name": "RUS",
      "LCID": 25,
      "IETF language tag": "ru",
      "flag code": ""
    },
    {
      "Culture .NET": "ru-RU",
      "English": "Russian (Russia)",
      "Native": "русский (Россия)",
      "Two letter": "ru",
      "Three letter": "rus",
      "Three letter language name": "RUS",
      "LCID": 1049,
      "IETF language tag": "ru-RU",
      "flag code": "ru Russia"
    },
    {
      "Culture .NET": "rw-RW",
      "English": "Kinyarwanda (Rwanda)",
      "Native": "Kinyarwanda (Rwanda)",
      "Two letter": "rw",
      "Three letter": "kin",
      "Three letter language name": "KIN",
      "LCID": 1159,
      "IETF language tag": "rw-RW",
      "flag code": "rw Rwanda"
    },
    {
      "Culture .NET": "sa",
      "English": "Sanskrit",
      "Native": "संस्कृत",
      "Two letter": "sa",
      "Three letter": "san",
      "Three letter language name": "SAN",
      "LCID": 79,
      "IETF language tag": "sa",
      "flag code": ""
    },
    {
      "Culture .NET": "sa-IN",
      "English": "Sanskrit (India)",
      "Native": "संस्कृत (भारतम्)",
      "Two letter": "sa",
      "Three letter": "san",
      "Three letter language name": "SAN",
      "LCID": 1103,
      "IETF language tag": "sa-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "sah-RU",
      "English": "Yakut (Russia)",
      "Native": "саха (Россия)",
      "Two letter": "sah",
      "Three letter": "sah",
      "Three letter language name": "SAH",
      "LCID": 1157,
      "IETF language tag": "sah-RU",
      "flag code": "ru Russia"
    },
    {
      "Culture .NET": "se-FI",
      "English": "Sami (Northern) (Finland)",
      "Native": "davvisámegiella (Suopma)",
      "Two letter": "se",
      "Three letter": "smg",
      "Three letter language name": "SMG",
      "LCID": 3131,
      "IETF language tag": "se-FI",
      "flag code": "fi Finland"
    },
    {
      "Culture .NET": "se-NO",
      "English": "Sami (Northern) (Norway)",
      "Native": "davvisámegiella (Norga)",
      "Two letter": "se",
      "Three letter": "sme",
      "Three letter language name": "SME",
      "LCID": 1083,
      "IETF language tag": "se-NO",
      "flag code": "no Norway"
    },
    {
      "Culture .NET": "se-SE",
      "English": "Sami (Northern) (Sweden)",
      "Native": "davvisámegiella (Ruoŧŧa)",
      "Two letter": "se",
      "Three letter": "smf",
      "Three letter language name": "SMF",
      "LCID": 2107,
      "IETF language tag": "se-SE",
      "flag code": "se Sweden"
    },
    {
      "Culture .NET": "si-LK",
      "English": "Sinhala (Sri Lanka)",
      "Native": "සිංහ (ශ්‍රී ලංකා)",
      "Two letter": "si",
      "Three letter": "sin",
      "Three letter language name": "SIN",
      "LCID": 1115,
      "IETF language tag": "si-LK",
      "flag code": "lk Sri Lanka"
    },
    {
      "Culture .NET": "sk",
      "English": "Slovak",
      "Native": "slovenčina",
      "Two letter": "sk",
      "Three letter": "slk",
      "Three letter language name": "SKY",
      "LCID": 27,
      "IETF language tag": "sk",
      "flag code": ""
    },
    {
      "Culture .NET": "sk-SK",
      "English": "Slovak (Slovakia)",
      "Native": "slovenčina (Slovenská republika)",
      "Two letter": "sk",
      "Three letter": "slk",
      "Three letter language name": "SKY",
      "LCID": 1051,
      "IETF language tag": "sk-SK",
      "flag code": "sk Slovakia"
    },
    {
      "Culture .NET": "sl",
      "English": "Slovenian",
      "Native": "slovenski",
      "Two letter": "sl",
      "Three letter": "slv",
      "Three letter language name": "SLV",
      "LCID": 36,
      "IETF language tag": "sl",
      "flag code": ""
    },
    {
      "Culture .NET": "sl-SI",
      "English": "Slovenian (Slovenia)",
      "Native": "slovenski (Slovenija)",
      "Two letter": "sl",
      "Three letter": "slv",
      "Three letter language name": "SLV",
      "LCID": 1060,
      "IETF language tag": "sl-SI",
      "flag code": "si Slovenia"
    },
    {
      "Culture .NET": "sma-NO",
      "English": "Sami (Southern) (Norway)",
      "Native": "åarjelsaemiengiele (Nöörje)",
      "Two letter": "sma",
      "Three letter": "sma",
      "Three letter language name": "SMA",
      "LCID": 6203,
      "IETF language tag": "sma-NO",
      "flag code": "no Norway"
    },
    {
      "Culture .NET": "sma-SE",
      "English": "Sami (Southern) (Sweden)",
      "Native": "åarjelsaemiengiele (Sveerje)",
      "Two letter": "sma",
      "Three letter": "smb",
      "Three letter language name": "SMB",
      "LCID": 7227,
      "IETF language tag": "sma-SE",
      "flag code": "se Sweden"
    },
    {
      "Culture .NET": "smj-NO",
      "English": "Sami (Lule) (Norway)",
      "Native": "julevusámegiella (Vuodna)",
      "Two letter": "smj",
      "Three letter": "smj",
      "Three letter language name": "SMJ",
      "LCID": 4155,
      "IETF language tag": "smj-NO",
      "flag code": "no Norway"
    },
    {
      "Culture .NET": "smj-SE",
      "English": "Sami (Lule) (Sweden)",
      "Native": "julevusámegiella (Svierik)",
      "Two letter": "smj",
      "Three letter": "smk",
      "Three letter language name": "SMK",
      "LCID": 5179,
      "IETF language tag": "smj-SE",
      "flag code": "se Sweden"
    },
    {
      "Culture .NET": "smn-FI",
      "English": "Sami (Inari) (Finland)",
      "Native": "sämikielâ (Suomâ)",
      "Two letter": "smn",
      "Three letter": "smn",
      "Three letter language name": "SMN",
      "LCID": 9275,
      "IETF language tag": "smn-FI",
      "flag code": "fi Finland"
    },
    {
      "Culture .NET": "sms-FI",
      "English": "Sami (Skolt) (Finland)",
      "Native": "sääm´ǩiõll (Lää´ddjânnam)",
      "Two letter": "sms",
      "Three letter": "sms",
      "Three letter language name": "SMS",
      "LCID": 8251,
      "IETF language tag": "sms-FI",
      "flag code": "fi Finland"
    },
    {
      "Culture .NET": "sq",
      "English": "Albanian",
      "Native": "shqipe",
      "Two letter": "sq",
      "Three letter": "sqi",
      "Three letter language name": "SQI",
      "LCID": 28,
      "IETF language tag": "sq",
      "flag code": ""
    },
    {
      "Culture .NET": "sq-AL",
      "English": "Albanian (Albania)",
      "Native": "shqipe (Shqipëria)",
      "Two letter": "sq",
      "Three letter": "sqi",
      "Three letter language name": "SQI",
      "LCID": 1052,
      "IETF language tag": "sq-AL",
      "flag code": "al Albania"
    },
    {
      "Culture .NET": "sr",
      "English": "Serbian",
      "Native": "srpski",
      "Two letter": "sr",
      "Three letter": "srp",
      "Three letter language name": "SRB",
      "LCID": 31770,
      "IETF language tag": "sr",
      "flag code": ""
    },
    {
      "Culture .NET": "sr-Cyrl-BA",
      "English": "Serbian (Cyrillic) (Bosnia and Herzegovina)",
      "Native": "српски (Босна и Херцеговина)",
      "Two letter": "sr",
      "Three letter": "srn",
      "Three letter language name": "SRN",
      "LCID": 7194,
      "IETF language tag": "sr-Cyrl-BA",
      "flag code": "ba Bosnia and Herzegovina"
    },
    // {
    //   "Culture .NET": "sr-Cyrl-CS",
    //   "English": "Serbian (Cyrillic) (Serbia and Montenegro (Former))",
    //   "Native": "српски (Србија и Црна Гора (Претходно))",
    //   "Two letter": "sr",
    //   "Three letter": "srp",
    //   "Three letter language name": "SRB",
    //   "LCID": 3098,
    //   "IETF language tag": "sr-Cyrl-CS",
    //   "flag code": "cs Former"
    // },
    {
      "Culture .NET": "sr-Cyrl-ME",
      "English": "Serbian (Cyrillic) (Montenegro)",
      "Native": "српски (Црна Гора)",
      "Two letter": "sr",
      "Three letter": "srp",
      "Three letter language name": "SRQ",
      "LCID": 12314,
      "IETF language tag": "sr-Cyrl-ME",
      "flag code": "me Montenegro"
    },
    {
      "Culture .NET": "sr-Cyrl-RS",
      "English": "Serbian (Cyrillic) (Serbia)",
      "Native": "српски (Србија)",
      "Two letter": "sr",
      "Three letter": "srp",
      "Three letter language name": "SRO",
      "LCID": 10266,
      "IETF language tag": "sr-Cyrl-RS",
      "flag code": "rs Serbia"
    },
    {
      "Culture .NET": "sr-Latn-BA",
      "English": "Serbian (Latin) (Bosnia and Herzegovina)",
      "Native": "srpski (Bosna i Hercegovina)",
      "Two letter": "sr",
      "Three letter": "srs",
      "Three letter language name": "SRS",
      "LCID": 6170,
      "IETF language tag": "sr-Latn-BA",
      "flag code": "ba Bosnia and Herzegovina"
    },
    // {
    //   "Culture .NET": "sr-Latn-CS",
    //   "English": "Serbian (Latin) (Serbia and Montenegro (Former))",
    //   "Native": "srpski (Srbija i Crna Gora (Prethodno))",
    //   "Two letter": "sr",
    //   "Three letter": "srp",
    //   "Three letter language name": "SRL",
    //   "LCID": 2074,
    //   "IETF language tag": "sr-Latn-CS",
    //   "flag code": "cs Former)"
    // },
    {
      "Culture .NET": "sr-Latn-ME",
      "English": "Serbian (Latin) (Montenegro)",
      "Native": "srpski (Crna Gora)",
      "Two letter": "sr",
      "Three letter": "srp",
      "Three letter language name": "SRP",
      "LCID": 11290,
      "IETF language tag": "sr-Latn-ME",
      "flag code": "me Montenegro"
    },
    {
      "Culture .NET": "sr-Latn-RS",
      "English": "Serbian (Latin) (Serbia)",
      "Native": "srpski (Srbija)",
      "Two letter": "sr",
      "Three letter": "srp",
      "Three letter language name": "SRM",
      "LCID": 9242,
      "IETF language tag": "sr-Latn-RS",
      "flag code": "rs Serbia"
    },
    {
      "Culture .NET": "sv",
      "English": "Swedish",
      "Native": "svenska",
      "Two letter": "sv",
      "Three letter": "swe",
      "Three letter language name": "SVE",
      "LCID": 29,
      "IETF language tag": "sv",
      "flag code": ""
    },
    {
      "Culture .NET": "sv-FI",
      "English": "Swedish (Finland)",
      "Native": "svenska (Finland)",
      "Two letter": "sv",
      "Three letter": "swe",
      "Three letter language name": "SVF",
      "LCID": 2077,
      "IETF language tag": "sv-FI",
      "flag code": "fi Finland"
    },
    {
      "Culture .NET": "sv-SE",
      "English": "Swedish (Sweden)",
      "Native": "svenska (Sverige)",
      "Two letter": "sv",
      "Three letter": "swe",
      "Three letter language name": "SVE",
      "LCID": 1053,
      "IETF language tag": "sv-SE",
      "flag code": "se Sweden"
    },
    {
      "Culture .NET": "sw",
      "English": "Kiswahili",
      "Native": "Kiswahili",
      "Two letter": "sw",
      "Three letter": "swa",
      "Three letter language name": "SWK",
      "LCID": 65,
      "IETF language tag": "sw",
      "flag code": ""
    },
    {
      "Culture .NET": "sw-KE",
      "English": "Kiswahili (Kenya)",
      "Native": "Kiswahili (Kenya)",
      "Two letter": "sw",
      "Three letter": "swa",
      "Three letter language name": "SWK",
      "LCID": 1089,
      "IETF language tag": "sw-KE",
      "flag code": "ke Kenya"
    },
    {
      "Culture .NET": "syr",
      "English": "Syriac",
      "Native": "ܣܘܪܝܝܐ",
      "Two letter": "syr",
      "Three letter": "syr",
      "Three letter language name": "SYR",
      "LCID": 90,
      "IETF language tag": "syr",
      "flag code": ""
    },
    {
      "Culture .NET": "syr-SY",
      "English": "Syriac (Syria)",
      "Native": "ܣܘܪܝܝܐ (سوريا)",
      "Two letter": "syr",
      "Three letter": "syr",
      "Three letter language name": "SYR",
      "LCID": 1114,
      "IETF language tag": "syr-SY",
      "flag code": "sy Syria"
    },
    {
      "Culture .NET": "ta",
      "English": "Tamil",
      "Native": "தமிழ்",
      "Two letter": "ta",
      "Three letter": "tam",
      "Three letter language name": "TAM",
      "LCID": 73,
      "IETF language tag": "ta",
      "flag code": ""
    },
    {
      "Culture .NET": "ta-IN",
      "English": "Tamil (India)",
      "Native": "தமிழ் (இந்தியா)",
      "Two letter": "ta",
      "Three letter": "tam",
      "Three letter language name": "TAM",
      "LCID": 1097,
      "IETF language tag": "ta-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "te",
      "English": "Telugu",
      "Native": "తెలుగు",
      "Two letter": "te",
      "Three letter": "tel",
      "Three letter language name": "TEL",
      "LCID": 74,
      "IETF language tag": "te",
      "flag code": ""
    },
    {
      "Culture .NET": "te-IN",
      "English": "Telugu (India)",
      "Native": "తెలుగు (భారత దేశం)",
      "Two letter": "te",
      "Three letter": "tel",
      "Three letter language name": "TEL",
      "LCID": 1098,
      "IETF language tag": "te-IN",
      "flag code": "in India"
    },
    {
      "Culture .NET": "tg-Cyrl-TJ",
      "English": "Tajik (Cyrillic) (Tajikistan)",
      "Native": "Тоҷикӣ (Тоҷикистон)",
      "Two letter": "tg",
      "Three letter": "tgk",
      "Three letter language name": "TAJ",
      "LCID": 1064,
      "IETF language tag": "tg-Cyrl-TJ",
      "flag code": "tj Tajikistan"
    },
    {
      "Culture .NET": "th",
      "English": "Thai",
      "Native": "ไทย",
      "Two letter": "th",
      "Three letter": "tha",
      "Three letter language name": "THA",
      "LCID": 30,
      "IETF language tag": "th",
      "flag code": ""
    },
    {
      "Culture .NET": "th-TH",
      "English": "Thai (Thailand)",
      "Native": "ไทย (ไทย)",
      "Two letter": "th",
      "Three letter": "tha",
      "Three letter language name": "THA",
      "LCID": 1054,
      "IETF language tag": "th-TH",
      "flag code": "th Thailand"
    },
    {
      "Culture .NET": "tk-TM",
      "English": "Turkmen (Turkmenistan)",
      "Native": "türkmençe (Türkmenistan)",
      "Two letter": "tk",
      "Three letter": "tuk",
      "Three letter language name": "TUK",
      "LCID": 1090,
      "IETF language tag": "tk-TM",
      "flag code": "tm Turkmenistan"
    },
    {
      "Culture .NET": "tn-ZA",
      "English": "Setswana (South Africa)",
      "Native": "Setswana (Aforika Borwa)",
      "Two letter": "tn",
      "Three letter": "tsn",
      "Three letter language name": "TSN",
      "LCID": 1074,
      "IETF language tag": "tn-ZA",
      "flag code": "za South Africa"
    },
    {
      "Culture .NET": "tr",
      "English": "Turkish",
      "Native": "Türkçe",
      "Two letter": "tr",
      "Three letter": "tur",
      "Three letter language name": "TRK",
      "LCID": 31,
      "IETF language tag": "tr",
      "flag code": ""
    },
    {
      "Culture .NET": "tr-TR",
      "English": "Turkish (Turkey)",
      "Native": "Türkçe (Türkiye)",
      "Two letter": "tr",
      "Three letter": "tur",
      "Three letter language name": "TRK",
      "LCID": 1055,
      "IETF language tag": "tr-TR",
      "flag code": "tr Turkey"
    },
    {
      "Culture .NET": "tt",
      "English": "Tatar",
      "Native": "Татар",
      "Two letter": "tt",
      "Three letter": "tat",
      "Three letter language name": "TTT",
      "LCID": 68,
      "IETF language tag": "tt",
      "flag code": ""
    },
    {
      "Culture .NET": "tt-RU",
      "English": "Tatar (Russia)",
      "Native": "Татар (Россия)",
      "Two letter": "tt",
      "Three letter": "tat",
      "Three letter language name": "TTT",
      "LCID": 1092,
      "IETF language tag": "tt-RU",
      "flag code": "ru Russia"
    },
    {
      "Culture .NET": "tzm-Latn-DZ",
      "English": "Tamazight (Latin) (Algeria)",
      "Native": "Tamazight (Djazaïr)",
      "Two letter": "tzm",
      "Three letter": "tzm",
      "Three letter language name": "TZM",
      "LCID": 2143,
      "IETF language tag": "tzm-Latn-DZ",
      "flag code": "dz Algeria"
    },
    {
      "Culture .NET": "ug-CN",
      "English": "Uyghur (People's Republic of China)",
      "Native": "ئۇيغۇرچە (جۇڭخۇا خەلق جۇمھۇرىيىتى)",
      "Two letter": "ug",
      "Three letter": "uig",
      "Three letter language name": "UIG",
      "LCID": 1152,
      "IETF language tag": "ug-CN",
      "flag code": "cn People's Republic of China"
    },
    {
      "Culture .NET": "uk",
      "English": "Ukrainian",
      "Native": "україньска",
      "Two letter": "uk",
      "Three letter": "ukr",
      "Three letter language name": "UKR",
      "LCID": 34,
      "IETF language tag": "uk",
      "flag code": ""
    },
    {
      "Culture .NET": "uk-UA",
      "English": "Ukrainian (Ukraine)",
      "Native": "україньска (Україна)",
      "Two letter": "uk",
      "Three letter": "ukr",
      "Three letter language name": "UKR",
      "LCID": 1058,
      "IETF language tag": "uk-UA",
      "flag code": "ua Ukraine"
    },
    {
      "Culture .NET": "ur",
      "English": "Urdu",
      "Native": "اُردو",
      "Two letter": "ur",
      "Three letter": "urd",
      "Three letter language name": "URD",
      "LCID": 32,
      "IETF language tag": "ur",
      "flag code": ""
    },
    {
      "Culture .NET": "ur-PK",
      "English": "Urdu (Islamic Republic of Pakistan)",
      "Native": "اُردو (پاکستان)",
      "Two letter": "ur",
      "Three letter": "urd",
      "Three letter language name": "URD",
      "LCID": 1056,
      "IETF language tag": "ur-PK",
      "flag code": "pk Islamic Republic of Pakistan"
    },
    {
      "Culture .NET": "uz",
      "English": "Uzbek",
      "Native": "U'zbek",
      "Two letter": "uz",
      "Three letter": "uzb",
      "Three letter language name": "UZB",
      "LCID": 67,
      "IETF language tag": "uz",
      "flag code": ""
    },
    {
      "Culture .NET": "uz-Cyrl-UZ",
      "English": "Uzbek (Cyrillic) (Uzbekistan)",
      "Native": "Ўзбек (Ўзбекистон)",
      "Two letter": "uz",
      "Three letter": "uzb",
      "Three letter language name": "UZB",
      "LCID": 2115,
      "IETF language tag": "uz-Cyrl-UZ",
      "flag code": "uz Uzbekistan"
    },
    {
      "Culture .NET": "uz-Latn-UZ",
      "English": "Uzbek (Latin) (Uzbekistan)",
      "Native": "U'zbek (U'zbekiston Respublikasi)",
      "Two letter": "uz",
      "Three letter": "uzb",
      "Three letter language name": "UZB",
      "LCID": 1091,
      "IETF language tag": "uz-Latn-UZ",
      "flag code": "uz Uzbekistan"
    },
    {
      "Culture .NET": "vi",
      "English": "Vietnamese",
      "Native": "Tiếng Việt",
      "Two letter": "vi",
      "Three letter": "vie",
      "Three letter language name": "VIT",
      "LCID": 42,
      "IETF language tag": "vi",
      "flag code": ""
    },
    {
      "Culture .NET": "vi-VN",
      "English": "Vietnamese (Vietnam)",
      "Native": "Tiếng Việt (Việt Nam)",
      "Two letter": "vi",
      "Three letter": "vie",
      "Three letter language name": "VIT",
      "LCID": 1066,
      "IETF language tag": "vi-VN",
      "flag code": "vn Vietnam"
    },
    {
      "Culture .NET": "wo-SN",
      "English": "Wolof (Senegal)",
      "Native": "Wolof (Sénégal)",
      "Two letter": "wo",
      "Three letter": "wol",
      "Three letter language name": "WOL",
      "LCID": 1160,
      "IETF language tag": "wo-SN",
      "flag code": "sn Senegal"
    },
    {
      "Culture .NET": "xh-ZA",
      "English": "isiXhosa (South Africa)",
      "Native": "isiXhosa (uMzantsi Afrika)",
      "Two letter": "xh",
      "Three letter": "xho",
      "Three letter language name": "XHO",
      "LCID": 1076,
      "IETF language tag": "xh-ZA",
      "flag code": "za South Africa"
    },
    {
      "Culture .NET": "yo-NG",
      "English": "Yoruba (Nigeria)",
      "Native": "Yoruba (Nigeria)",
      "Two letter": "yo",
      "Three letter": "yor",
      "Three letter language name": "YOR",
      "LCID": 1130,
      "IETF language tag": "yo-NG",
      "flag code": "ng Nigeria"
    },
    {
      "Culture .NET": "zh-CHS",
      "English": "Chinese (Simplified)",
      "Native": "中文(简体)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "CHS",
      "LCID": 4,
      "IETF language tag": "zh-Hans",
      "flag code": ""
    },
    {
      "Culture .NET": "zh-CHT",
      "English": "Chinese (Traditional)",
      "Native": "中文(繁體)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "CHT",
      "LCID": 31748,
      "IETF language tag": "zh-Hant",
      "flag code": ""
    },
    {
      "Culture .NET": "zh-CN",
      "English": "Chinese (People's Republic of China)",
      "Native": "中文(中华人民共和国)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "CHS",
      "LCID": 2052,
      "IETF language tag": "zh-CN",
      "flag code": "cn People's Republic of China"
    },
    {
      "Culture .NET": "zh-HK",
      "English": "Chinese (Hong Kong S.A.R.)",
      "Native": "中文(香港特别行政區)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "ZHH",
      "LCID": 3076,
      "IETF language tag": "zh-HK",
      "flag code": "hk Hong Kong S.A.R."
    },
    {
      "Culture .NET": "zh-MO",
      "English": "Chinese (Macao S.A.R.)",
      "Native": "中文(澳門特别行政區)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "ZHM",
      "LCID": 5124,
      "IETF language tag": "zh-MO",
      "flag code": "mo Macao S.A.R."
    },
    {
      "Culture .NET": "zh-SG",
      "English": "Chinese (Singapore)",
      "Native": "中文(新加坡)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "ZHI",
      "LCID": 4100,
      "IETF language tag": "zh-SG",
      "flag code": "sg Singapore"
    },
    {
      "Culture .NET": "zh-TW",
      "English": "Chinese (Taiwan)",
      "Native": "中文(台灣)",
      "Two letter": "zh",
      "Three letter": "zho",
      "Three letter language name": "CHT",
      "LCID": 1028,
      "IETF language tag": "zh-TW",
      "flag code": "tw Taiwan"
    },
    {
      "Culture .NET": "zu-ZA",
      "English": "isiZulu (South Africa)",
      "Native": "isiZulu (iNingizimu Afrika)",
      "Two letter": "zu",
      "Three letter": "zul",
      "Three letter language name": "ZUL",
      "LCID": 1077,
      "IETF language tag": "zu-ZA",
      "flag code": "za South Africa"
    }
  ]

  googleLanguageSupport = [
    {
      "Language": "Afrikaans",
      "ISO-639 code": "af"
    },
    {
      "Language": "Albanian",
      "ISO-639 code": "sq"
    },
    {
      "Language": "Amharic",
      "ISO-639 code": "am"
    },
    {
      "Language": "Arabic",
      "ISO-639 code": "ar"
    },
    {
      "Language": "Armenian",
      "ISO-639 code": "hy"
    },
    {
      "Language": "Assamese",
      "ISO-639 code": "as"
    },
    {
      "Language": "Aymara",
      "ISO-639 code": "ay"
    },
    {
      "Language": "Azerbaijani",
      "ISO-639 code": "az"
    },
    {
      "Language": "Bambara",
      "ISO-639 code": "bm"
    },
    {
      "Language": "Basque",
      "ISO-639 code": "eu"
    },
    {
      "Language": "Belarusian",
      "ISO-639 code": "be"
    },
    {
      "Language": "Bengali",
      "ISO-639 code": "bn"
    },
    {
      "Language": "Bhojpuri",
      "ISO-639 code": "bho"
    },
    {
      "Language": "Bosnian",
      "ISO-639 code": "bs"
    },
    {
      "Language": "Bulgarian",
      "ISO-639 code": "bg"
    },
    {
      "Language": "Catalan",
      "ISO-639 code": "ca"
    },
    {
      "Language": "Cebuano",
      "ISO-639 code": "ceb"
    },
    {
      "Language": "Chinese (Simplified)",
      "ISO-639 code": "zh-CN or zh (BCP-47)"
    },
    {
      "Language": "Chinese (Traditional)",
      "ISO-639 code": "zh-TW (BCP-47)"
    },
    {
      "Language": "Corsican",
      "ISO-639 code": "co"
    },
    {
      "Language": "Croatian",
      "ISO-639 code": "hr"
    },
    {
      "Language": "Czech",
      "ISO-639 code": "cs"
    },
    {
      "Language": "Danish",
      "ISO-639 code": "da"
    },
    {
      "Language": "Dhivehi",
      "ISO-639 code": "dv"
    },
    {
      "Language": "Dogri",
      "ISO-639 code": "doi"
    },
    {
      "Language": "Dutch",
      "ISO-639 code": "nl"
    },
    {
      "Language": "English",
      "ISO-639 code": "en"
    },
    {
      "Language": "Esperanto",
      "ISO-639 code": "eo"
    },
    {
      "Language": "Estonian",
      "ISO-639 code": "et"
    },
    {
      "Language": "Ewe",
      "ISO-639 code": "ee"
    },
    {
      "Language": "Filipino (Tagalog)",
      "ISO-639 code": "fil"
    },
    {
      "Language": "Finnish",
      "ISO-639 code": "fi"
    },
    {
      "Language": "French",
      "ISO-639 code": "fr"
    },
    {
      "Language": "Frisian",
      "ISO-639 code": "fy"
    },
    {
      "Language": "Galician",
      "ISO-639 code": "gl"
    },
    {
      "Language": "Georgian",
      "ISO-639 code": "ka"
    },
    {
      "Language": "German",
      "ISO-639 code": "de"
    },
    {
      "Language": "Greek",
      "ISO-639 code": "el"
    },
    {
      "Language": "Guarani",
      "ISO-639 code": "gn"
    },
    {
      "Language": "Gujarati",
      "ISO-639 code": "gu"
    },
    {
      "Language": "Haitian Creole",
      "ISO-639 code": "ht"
    },
    {
      "Language": "Hausa",
      "ISO-639 code": "ha"
    },
    {
      "Language": "Hawaiian",
      "ISO-639 code": "haw"
    },
    {
      "Language": "Hebrew",
      "ISO-639 code": "he or iw"
    },
    {
      "Language": "Hindi",
      "ISO-639 code": "hi"
    },
    {
      "Language": "Hmong",
      "ISO-639 code": "hmn"
    },
    {
      "Language": "Hungarian",
      "ISO-639 code": "hu"
    },
    {
      "Language": "Icelandic",
      "ISO-639 code": "is"
    },
    {
      "Language": "Igbo",
      "ISO-639 code": "ig"
    },
    {
      "Language": "Ilocano",
      "ISO-639 code": "ilo"
    },
    {
      "Language": "Indonesian",
      "ISO-639 code": "id"
    },
    {
      "Language": "Irish",
      "ISO-639 code": "ga"
    },
    {
      "Language": "Italian",
      "ISO-639 code": "it"
    },
    {
      "Language": "Japanese",
      "ISO-639 code": "ja"
    },
    {
      "Language": "Javanese",
      "ISO-639 code": "jv or jw"
    },
    {
      "Language": "Kannada",
      "ISO-639 code": "kn"
    },
    {
      "Language": "Kazakh",
      "ISO-639 code": "kk"
    },
    {
      "Language": "Khmer",
      "ISO-639 code": "km"
    },
    {
      "Language": "Kinyarwanda",
      "ISO-639 code": "rw"
    },
    {
      "Language": "Konkani",
      "ISO-639 code": "gom"
    },
    {
      "Language": "Korean",
      "ISO-639 code": "ko"
    },
    {
      "Language": "Krio",
      "ISO-639 code": "kri"
    },
    {
      "Language": "Kurdish",
      "ISO-639 code": "ku"
    },
    {
      "Language": "Kurdish (Sorani)",
      "ISO-639 code": "ckb"
    },
    {
      "Language": "Kyrgyz",
      "ISO-639 code": "ky"
    },
    {
      "Language": "Lao",
      "ISO-639 code": "lo"
    },
    {
      "Language": "Latin",
      "ISO-639 code": "la"
    },
    {
      "Language": "Latvian",
      "ISO-639 code": "lv"
    },
    {
      "Language": "Lingala",
      "ISO-639 code": "ln"
    },
    {
      "Language": "Lithuanian",
      "ISO-639 code": "lt"
    },
    {
      "Language": "Luganda",
      "ISO-639 code": "lg"
    },
    {
      "Language": "Luxembourgish",
      "ISO-639 code": "lb"
    },
    {
      "Language": "Macedonian",
      "ISO-639 code": "mk"
    },
    {
      "Language": "Maithili",
      "ISO-639 code": "mai"
    },
    {
      "Language": "Malagasy",
      "ISO-639 code": "mg"
    },
    {
      "Language": "Malay",
      "ISO-639 code": "ms"
    },
    {
      "Language": "Malayalam",
      "ISO-639 code": "ml"
    },
    {
      "Language": "Maltese",
      "ISO-639 code": "mt"
    },
    {
      "Language": "Maori",
      "ISO-639 code": "mi"
    },
    {
      "Language": "Marathi",
      "ISO-639 code": "mr"
    },
    {
      "Language": "Meiteilon (Manipuri)",
      "ISO-639 code": "mni-Mtei"
    },
    {
      "Language": "Mizo",
      "ISO-639 code": "lus"
    },
    {
      "Language": "Mongolian",
      "ISO-639 code": "mn"
    },
    {
      "Language": "Myanmar (Burmese)",
      "ISO-639 code": "my"
    },
    {
      "Language": "Nepali",
      "ISO-639 code": "ne"
    },
    {
      "Language": "Norwegian",
      "ISO-639 code": "no"
    },
    {
      "Language": "Nyanja (Chichewa)",
      "ISO-639 code": "ny"
    },
    {
      "Language": "Odia (Oriya)",
      "ISO-639 code": "or"
    },
    {
      "Language": "Oromo",
      "ISO-639 code": "om"
    },
    {
      "Language": "Pashto",
      "ISO-639 code": "ps"
    },
    {
      "Language": "Persian",
      "ISO-639 code": "fa"
    },
    {
      "Language": "Polish",
      "ISO-639 code": "pl"
    },
    {
      "Language": "Portuguese (Portugal, Brazil)",
      "ISO-639 code": "pt"
    },
    {
      "Language": "Punjabi",
      "ISO-639 code": "pa"
    },
    {
      "Language": "Quechua",
      "ISO-639 code": "qu"
    },
    {
      "Language": "Romanian",
      "ISO-639 code": "ro"
    },
    {
      "Language": "Russian",
      "ISO-639 code": "ru"
    },
    {
      "Language": "Samoan",
      "ISO-639 code": "sm"
    },
    {
      "Language": "Sanskrit",
      "ISO-639 code": "sa"
    },
    {
      "Language": "Scots Gaelic",
      "ISO-639 code": "gd"
    },
    {
      "Language": "Sepedi",
      "ISO-639 code": "nso"
    },
    {
      "Language": "Serbian",
      "ISO-639 code": "sr"
    },
    {
      "Language": "Sesotho",
      "ISO-639 code": "st"
    },
    {
      "Language": "Shona",
      "ISO-639 code": "sn"
    },
    {
      "Language": "Sindhi",
      "ISO-639 code": "sd"
    },
    {
      "Language": "Sinhala (Sinhalese)",
      "ISO-639 code": "si"
    },
    {
      "Language": "Slovak",
      "ISO-639 code": "sk"
    },
    {
      "Language": "Slovenian",
      "ISO-639 code": "sl"
    },
    {
      "Language": "Somali",
      "ISO-639 code": "so"
    },
    {
      "Language": "Spanish",
      "ISO-639 code": "es"
    },
    {
      "Language": "Sundanese",
      "ISO-639 code": "su"
    },
    {
      "Language": "Swahili",
      "ISO-639 code": "sw"
    },
    {
      "Language": "Swedish",
      "ISO-639 code": "sv"
    },
    {
      "Language": "Tagalog (Filipino)",
      "ISO-639 code": "tl"
    },
    {
      "Language": "Tajik",
      "ISO-639 code": "tg"
    },
    {
      "Language": "Tamil",
      "ISO-639 code": "ta"
    },
    {
      "Language": "Tatar",
      "ISO-639 code": "tt"
    },
    {
      "Language": "Telugu",
      "ISO-639 code": "te"
    },
    {
      "Language": "Thai",
      "ISO-639 code": "th"
    },
    {
      "Language": "Tigrinya",
      "ISO-639 code": "ti"
    },
    {
      "Language": "Tsonga",
      "ISO-639 code": "ts"
    },
    {
      "Language": "Turkish",
      "ISO-639 code": "tr"
    },
    {
      "Language": "Turkmen",
      "ISO-639 code": "tk"
    },
    {
      "Language": "Twi (Akan)",
      "ISO-639 code": "ak"
    },
    {
      "Language": "Ukrainian",
      "ISO-639 code": "uk"
    },
    {
      "Language": "Urdu",
      "ISO-639 code": "ur"
    },
    {
      "Language": "Uyghur",
      "ISO-639 code": "ug"
    },
    {
      "Language": "Uzbek",
      "ISO-639 code": "uz"
    },
    {
      "Language": "Vietnamese",
      "ISO-639 code": "vi"
    },
    {
      "Language": "Welsh",
      "ISO-639 code": "cy"
    },
    {
      "Language": "Xhosa",
      "ISO-639 code": "xh"
    },
    {
      "Language": "Yiddish",
      "ISO-639 code": "yi"
    },
    {
      "Language": "Yoruba",
      "ISO-639 code": "yo"
    },
    {
      "Language": "Zulu",
      "ISO-639 code": "zu"
    }
  ]

  constructor() { }

  getText(textId: any, addon: any = "") {
    if (this.selectedLanguage === "english") {
      return this.englishText[textId] + addon;
    } else {
      return ""
    }
  }


}
